import ArgonTypography from "components/ArgonTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import { Close as CloseIcon } from "@mui/icons-material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { GoogleMap, useLoadScript, MarkerF } from "@react-google-maps/api";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ArgonBox from "components/ArgonBox";
import Table from "examples/Tables/Table";
import Card from "@mui/material/Card";
import Footer from "examples/Footer";
import breakpoints from "assets/theme/base/breakpoints";
import { TextField } from "@mui/material";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import { Link, useParams } from "react-router-dom";
import tutorTableData from "Views/people/tutor/data/tutorTableData";
import {
  Box,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Switch,
  Radio,
  RadioGroup,
  Autocomplete,
  Chip,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";

import { useState, useEffect } from "react";

import { Grid } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import SchoolIcon from "@mui/icons-material/School";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WorkIcon from "@mui/icons-material/Work";
// import { Chip } from "@mui/material";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";

import { Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material";
import { CircularProgress } from "@mui/material";
import Dropdown from "components/CustomDropdown/Dropdown";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";
import TutoProfileCard from "./TutoProfileCard";
import FileUploader from "components/FileUploader/FileUploader";
import axios, { baseURL } from "utils/api";
import { toast } from "react-toastify";
import TeachingPreferenceTableData from "./data/TeachingPrefernceTableData";
import EducationalQualificationTableData from "./data/EducationalQualificationTableData";
import LocationPreferenceTableData from "./data/LocationPreferenceTableData";
import TeachingExperienceTableData from "./data/TeachingExperienceTableData";
import CertificateTableData from "./data/CertificateTableData";
import AdditionalDocumentsTableData from "./data/AdditionalDocumentsTableData";
import PaymentDetailsTableData from "./data/PaymentDetailsTableData";
import AssessmentIcon from "@mui/icons-material/Assessment";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import MeetingDialog from "components/MeetingDialog/MeetingDialog";

// Google Maps API Key - Replace with your own key
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "YOUR_GOOGLE_MAPS_API_KEY";

const PRICING_LEVEL_GROUPS = [
  {
    label: "ACADEMICS - School Level",
    options: [
      { label: "KG (Preprimary) - LKG, UKG", value: "KG" },
      { label: "Primary - 1st to 5th", value: "PRIMARY" },
      { label: "Middle - 6th to 8th", value: "MIDDLE" },
      { label: "Secondary - 9th and 10th", value: "SECONDARY" },
      { label: "Higher - 11th and 12th", value: "HIGHER" },
    ],
  },
  {
    label: "ACADEMICS - Competitive Level",
    options: [
      { label: "JEE - MAINS", value: "JEE_MAINS" },
      { label: "NEET", value: "NEET" },
      { label: "UPSC Civil Services Examination", value: "UPSC_CSE" },
      { label: "CAT", value: "CAT" },
      { label: "SSC CGL", value: "SSC_CGL" },
      { label: "GATE", value: "GATE" },
      { label: "IBPS PO", value: "IBPS_PO" },
      { label: "RRB NTPC", value: "RRB_NTPC" },
      { label: "CLAT", value: "CLAT" },
      { label: "NDA", value: "NDA" },
    ],
  },
  {
    label: "NON ACADEMICS - Language",
    options: [
      { label: "English", value: "LANGUAGE_ENGLISH" },
      { label: "French", value: "LANGUAGE_FRENCH" },
      { label: "Hindi", value: "LANGUAGE_HINDI" },
      { label: "Sanskrit", value: "LANGUAGE_SANSKRIT" },
      { label: "Urdu", value: "LANGUAGE_URDU" },
      { label: "German", value: "LANGUAGE_GERMAN" },
    ],
  },
  {
    label: "NON ACADEMICS - Hobby & Fitness",
    options: [
      { label: "Zumba", value: "HOBBY_ZUMBA" },
      { label: "Dance", value: "HOBBY_DANCE" },
      { label: "Music", value: "HOBBY_MUSIC" },
      { label: "Yoga", value: "HOBBY_YOGA" },
    ],
  },
];

const PRICING_LEVEL_VALUES = PRICING_LEVEL_GROUPS.flatMap((group) =>
  group.options.map((option) => option.value)
);

const PRICING_LEVEL_LABELS = Object.fromEntries(
  PRICING_LEVEL_GROUPS.flatMap((group) =>
    group.options.map((option) => [option.value, option.label])
  )
);

const getTutorSlotId = (slot) => {
  if (!slot) return "";
  if (typeof slot === "string") return slot;
  return slot._id || slot.id || "";
};

const getTutorSlotLabel = (slot) => {
  if (!slot) return "";
  const start = slot.startTime || slot.start || "";
  const end = slot.endTime || slot.end || "";
  if (start && end) return `${start} - ${end}`;
  return start || end || "";
};

const normalizeTutorSlots = (response) => {
  if (Array.isArray(response?.data?.data?.slots)) return response.data.data.slots;
  if (Array.isArray(response?.data?.slots)) return response.data.slots;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

function BasicDetails() {
  // Load Google Maps script
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  });

  // State for all subjects
  const [allSubjects, setAllSubjects] = useState([]);
  // Fetch all subjects for dropdown
  useEffect(() => {
    axios
      .get(`${baseURL}/subjects`)
      .then((res) => {
        if (res.data.success) {
          // Map to { label, value } for dropdown
          const options = res.data.data.map((subj) => ({ label: subj.name, value: subj._id }));
          setAllSubjects(options);
        }
      })
      .catch((err) => {
        console.error("Error fetching subjects for dropdown:", err);
      });
  }, []);

  // Fetch all boards for dropdown
  useEffect(() => {
    axios
      .get(`${baseURL}/boards?limit=100`)
      .then((res) => {
        if (res.data.success) {
          // Filter out deleted boards
          const activeBoards = (res.data.data || []).filter((board) => !board.isDeleted);
          const options = activeBoards.map((board) => ({ label: board.name, value: board._id }));
          setAllBoards(options);
        }
      })
      .catch((err) => {
        console.error("Error fetching boards for dropdown:", err);
      });
  }, []);

  // Fetch all classes for dropdown
  useEffect(() => {
    axios
      .get(`${baseURL}/classes?limit=100`)
      .then((res) => {
        if (res.data.success) {
          // Filter out deleted classes
          const activeClasses = (res.data.data || []).filter((cls) => !cls.isDeleted);
          const options = activeClasses.map((cls) => ({ label: cls.name, value: cls._id }));
          setAllClasses(options);
        }
      })
      .catch((err) => {
        console.error("Error fetching classes for dropdown:", err);
      });
  }, []);

  // Fetch all qualifications for dropdown
  useEffect(() => {
    axios
      .get(`${baseURL}/qualifications?limit=100`)
      .then((res) => {
        if (res.data.success) {
          // Filter out deleted qualifications
          const activeQualifications = (res.data.data || []).filter((qual) => !qual.isDeleted);
          const options = activeQualifications.map((qual) => ({
            label: qual.name,
            value: qual._id,
          }));
          setAllQualifications(options);
        }
      })
      .catch((err) => {
        console.error("Error fetching qualifications for dropdown:", err);
      });
  }, []);
  const [aadhaarFiles, setAadhaarFiles] = useState([]);
  const [aadhaarFrontFiles, setAadhaarFrontFiles] = useState([]);
  const [aadhaarBackFiles, setAadhaarBackFiles] = useState([]);
  const [aadhaarFrontPreview, setAadhaarFrontPreview] = useState(null);
  const [aadhaarBackPreview, setAadhaarBackPreview] = useState(null);

  const statusOptions = [
    "Adaptable & Reliable",
    "Demanding or Money-Focused",
    "Rigid or Difficult to Manage",
    "Premium Client Ready",
    "Not Suitable for Premium Clients",
    "Inconsistent or Unreliable",
    "Underconfident or Needs Improvement",
    "Inactive or Seeking Classes",
    "Dedicated & Professional",
    "Patient & Empathetic",
  ];

  const [availability, setavailability] = useState("");
  const [open, setOpen] = useState(false);
  const [experiencePoints, setExperiencePoints] = useState([]);
  const [educationPoints, setEducationPoints] = useState([]);

  // Evaluation states
  const [openEvaluation, setOpenEvaluation] = useState(false);
  const [evaluation, setEvaluation] = useState(null);
  const [savingEvaluation, setSavingEvaluation] = useState(false);
  const [evaluationForm, setEvaluationForm] = useState({
    introduction: 0,
    english: "BASIC",
    englishRating: 1,
    hindiRating: 1,
    tonePitch: "MEDIUM",
    crossQuestions: 1,
    subjectRatings: [],
    startingFromBasics: false,
    smoothExplanations: false,
    lisp: false,
    lispCategory: "",
    remarks: "",
    confidenceLevel: 1,
    personalityWise: "",
  });
  const [statusSelected, setStatusSelected] = useState([]);

  // Approval/Rejection Dialog States
  const [openApprovalDialog, setOpenApprovalDialog] = useState(false);
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [approvalForm, setApprovalForm] = useState({
    approvalStatus: "",
    rejectionReason: "",
    badgeLevel: "",
    edushalaMargin: "",
    levelBasedPricing: [],
  });

  // Meeting Dialog States
  const [meetingDialog, setMeetingDialog] = useState({
    open: false,
    existingMeeting: null,
  });
  const [loadingMeeting, setLoadingMeeting] = useState(false);
  const [hasMeeting, setHasMeeting] = useState(false);

  // Image Modal States
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [dob, setDob] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [mode1, setMode1] = useState(""); // Mode of Tuition
  const [level, setLevel] = useState(""); // Level/Badge
  const [phone, setPhone] = useState("");
  const [alternateMobile, setAlternateMobile] = useState("");
  const [address, setAddress] = useState("");
  const [about, setAbout] = useState("");
  const [experience, setExperience] = useState("");
  const [description, setDescription] = useState("");
  // const [cityAddress, setCityAddress] = useState("");
  // const [stateName, setStateName] = useState("");
  const [gender, setGender] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [reviewsCount, setReviewsCount] = useState(0);
  const [averageRating, setAverageRating] = useState(0);

  // Loading state for form submission
  const [updateLoading, setUpdateLoading] = useState(false);
  const [teachingPrefLoading, setTeachingPrefLoading] = useState(false);
  const [eduQualLoading, setEduQualLoading] = useState(false);
  const [locationPrefLoading, setLocationPrefLoading] = useState(false);
  const [teachingExpLoading, setTeachingExpLoading] = useState(false);

  // Teaching Preferences Dialog States
  const [teachingPrefOpen, setTeachingPrefOpen] = useState(false);
  const [allBoards, setAllBoards] = useState([]);
  const [allClasses, setAllClasses] = useState([]);
  const [allQualifications, setAllQualifications] = useState([]);
  const [teachingPreferences, setTeachingPreferences] = useState([]);
  const [refreshTeachingPref, setRefreshTeachingPref] = useState(false);
  const [dataRefreshKey, setDataRefreshKey] = useState(0);

  // Educational Qualifications Dialog States
  const [eduQualOpen, setEduQualOpen] = useState(false);
  const [eduQualifications, setEduQualifications] = useState([]);

  // Educational Qualification marksheet states
  const [eduQualMarksheetFiles, setEduQualMarksheetFiles] = useState({});
  const [eduQualMarksheetPreviews, setEduQualMarksheetPreviews] = useState({});

  // Location Preferences Dialog States
  const [locationPrefOpen, setLocationPrefOpen] = useState(false);
  const [locationPreferences, setLocationPreferences] = useState([]);
  const [selectedLocationIndex, setSelectedLocationIndex] = useState(0);
  const [mapCenter, setMapCenter] = useState({ lat: 28.6139, lng: 77.209 }); // Default to Delhi

  // Teaching Experience Dialog States
  const [teachingExpOpen, setTeachingExpOpen] = useState(false);
  const [teachingExperience, setTeachingExperience] = useState([]);

  // Certificate Dialog States
  const [certificateOpen, setCertificateOpen] = useState(false);
  const [certificates, setCertificates] = useState([]);
  const [certificateLoading, setCertificateLoading] = useState(false);

  // Additional Documents Dialog States
  const [additionalDocsOpen, setAdditionalDocsOpen] = useState(false);
  const [additionalDocuments, setAdditionalDocuments] = useState([]);
  const [additionalDocsLoading, setAdditionalDocsLoading] = useState(false);

  // Payment Details Dialog States
  const [paymentDetailsOpen, setPaymentDetailsOpen] = useState(false);
  const [paymentMode, setPaymentMode] = useState("BANK");
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [upiId, setUpiId] = useState("");
  const [paymentDetailsLoading, setPaymentDetailsLoading] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleTeachingPrefOpen = () => {
    // Always reinitialize teaching preferences from tutor data
    if (
      tutor &&
      (tutor.subjects?.length > 0 || tutor.boards?.length > 0 || tutor.classes?.length > 0)
    ) {
      // Create a single preference with all subjects, boards, and classes
      const preference = {
        subjects: tutor.subjects || [],
        boards: tutor.boards || [],
        class: tutor.classes?.[0] ? { _id: tutor.classes[0]._id } : undefined,
      };
      setTeachingPreferences([preference]);
    } else {
      // If dropdown options are available, prefill new preference with empty arrays
      const defaultPref = {
        subjects: [],
        boards: [],
        class: allClasses && allClasses.length > 0 ? { _id: allClasses[0].value } : undefined,
      };
      setTeachingPreferences([defaultPref]);
    }
    setTeachingPrefOpen(true);
  };
  const handleTeachingPrefClose = () => {
    setTeachingPrefOpen(false);
    // Don't reset preferences - keep them for next open
  };

  const handleEduQualOpen = () => {
    // Initialize marksheet states for existing qualifications
    const marksheetPreviews = {};
    const marksheetFiles = {};
    eduQualifications.forEach((qual, index) => {
      if (qual.marksheet) {
        marksheetPreviews[index] = qual.marksheet;
      }
      marksheetFiles[index] = [];
    });
    setEduQualMarksheetPreviews(marksheetPreviews);
    setEduQualMarksheetFiles(marksheetFiles);
    setEduQualOpen(true);
  };
  const handleEduQualClose = () => {
    setEduQualOpen(false);
    setEduQualifications([]);
    setEduQualMarksheetFiles({});
    setEduQualMarksheetPreviews({});
  };

  const handleLocationPrefOpen = () => {
    // Set selected index to 0 (first location)
    setSelectedLocationIndex(0);
    // Set map center to first location if available
    if (
      locationPreferences.length > 0 &&
      locationPreferences[0]?.lat &&
      locationPreferences[0]?.lng
    ) {
      setMapCenter({
        lat: parseFloat(locationPreferences[0].lat),
        lng: parseFloat(locationPreferences[0].lng),
      });
    }
    setLocationPrefOpen(true);
  };
  const handleLocationPrefClose = () => {
    setLocationPrefOpen(false);
    setSelectedLocationIndex(0); // Reset to first location
  };

  const handleTeachingExpOpen = () => setTeachingExpOpen(true);
  const handleTeachingExpClose = () => setTeachingExpOpen(false);

  // Certificate handlers
  const handleCertificateOpen = () => {
    // Load existing certificates from tutor data
    if (tutor && tutor.certificates && tutor.certificates.length > 0) {
      setCertificates(tutor.certificates.map((cert) => ({ ...cert })));
    } else {
      setCertificates([{ certificateName: "", certificateImage: "" }]);
    }
    setCertificateOpen(true);
  };

  const handleCertificateClose = () => {
    setCertificateOpen(false);
    setCertificates([]);
  };

  const handleAddCertificate = () => {
    setCertificates([...certificates, { certificateName: "", certificateImage: "" }]);
  };

  const handleRemoveCertificate = (index) => {
    const updatedCerts = certificates.filter((_, i) => i !== index);
    setCertificates(
      updatedCerts.length > 0 ? updatedCerts : [{ certificateName: "", certificateImage: "" }]
    );
  };

  const handleCertificateChange = (index, field, value) => {
    const updatedCerts = [...certificates];
    if (!updatedCerts[index]) {
      updatedCerts[index] = { certificateName: "", certificateImage: "" };
    }
    updatedCerts[index][field] = value;
    setCertificates(updatedCerts);
  };

  const handleCertificateImageUpload = (index, file) => {
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      const updatedCerts = [...certificates];
      if (!updatedCerts[index]) {
        updatedCerts[index] = { certificateName: "", certificateImage: "" };
      }
      updatedCerts[index].certificateImage = reader.result;
      updatedCerts[index].certificateFile = file;
      setCertificates(updatedCerts);
    };
    reader.readAsDataURL(file);
  };

  // Additional Documents handlers
  const handleAdditionalDocsOpen = () => {
    // Load existing additional documents from tutor data
    if (tutor && tutor.additionalDocuments && tutor.additionalDocuments.length > 0) {
      setAdditionalDocuments(tutor.additionalDocuments.map((doc) => ({ ...doc })));
    } else {
      setAdditionalDocuments([{ documentTitle: "", documentUrl: "" }]);
    }
    setAdditionalDocsOpen(true);
  };

  const handleAdditionalDocsClose = () => {
    setAdditionalDocsOpen(false);
    setAdditionalDocuments([]);
  };

  const handleAddAdditionalDoc = () => {
    setAdditionalDocuments([...additionalDocuments, { documentTitle: "", documentUrl: "" }]);
  };

  const handleRemoveAdditionalDoc = (index) => {
    const updatedDocs = additionalDocuments.filter((_, i) => i !== index);
    setAdditionalDocuments(
      updatedDocs.length > 0 ? updatedDocs : [{ documentTitle: "", documentUrl: "" }]
    );
  };

  const handleAdditionalDocChange = (index, field, value) => {
    const updatedDocs = [...additionalDocuments];
    if (!updatedDocs[index]) {
      updatedDocs[index] = { documentTitle: "", documentUrl: "" };
    }
    updatedDocs[index][field] = value;
    setAdditionalDocuments(updatedDocs);
  };

  const handleAdditionalDocUpload = (index, file) => {
    if (!file) return;

    const updatedDocs = [...additionalDocuments];
    if (!updatedDocs[index]) {
      updatedDocs[index] = { documentTitle: "", documentUrl: "" };
    }
    // Store file object and file name for display
    updatedDocs[index].documentFile = file;
    updatedDocs[index].fileName = file.name;
    updatedDocs[index].fileSize = (file.size / 1024).toFixed(2); // Size in KB
    setAdditionalDocuments(updatedDocs);
  };

  const handleUpdateAdditionalDocs = async (e) => {
    e.preventDefault();
    setAdditionalDocsLoading(true);

    // Validation
    const hasEmptyTitle = additionalDocuments.some((doc) => !doc.documentTitle?.trim());
    const hasEmptyFile = additionalDocuments.some((doc) => !doc.documentUrl && !doc.documentFile);

    if (hasEmptyTitle) {
      toast.error("Please enter document title for all documents");
      setAdditionalDocsLoading(false);
      return;
    }

    if (hasEmptyFile) {
      toast.error("Please upload file for all documents");
      setAdditionalDocsLoading(false);
      return;
    }

    try {
      const formData = new FormData();

      // Prepare additional documents data
      const additionalDocsData = additionalDocuments.map((doc) => {
        const docData = {
          documentTitle: doc.documentTitle,
          documentUrl: doc.documentUrl,
          ...(doc._id && { _id: doc._id }),
          ...(doc.uploadedAt && { uploadedAt: doc.uploadedAt }),
        };

        // Mark if this document needs a new file upload
        if (doc.documentFile) {
          docData.needsUpload = true;
        }

        return docData;
      });

      // Add additional documents as JSON string
      formData.append("additionalDocuments", JSON.stringify(additionalDocsData));

      // Add files
      additionalDocuments.forEach((doc) => {
        if (doc.documentFile) {
          formData.append("additionalDocumentFile", doc.documentFile);
        }
      });

      const res = await axios.put(`${baseURL}/tutor/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        // Refresh tutor data
        const tutorRes = await axios.get(`${baseURL}/tutor?id=${id}`);
        setTutor(tutorRes.data.data);
        setDataRefreshKey((prev) => prev + 1);

        toast.success("Additional documents updated successfully!");
        handleAdditionalDocsClose();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update additional documents");
      console.error("Error updating additional documents:", err);
    } finally {
      setAdditionalDocsLoading(false);
    }
  };

  // Payment Details handlers
  const handlePaymentDetailsOpen = () => {
    // Load existing payment details from tutor data
    if (tutor && tutor.paymentDetails && tutor.paymentDetails.mode) {
      const pd = tutor.paymentDetails;
      setPaymentMode(pd.mode || "BANK");
      setBankName(pd.bankName || "");
      setAccountNumber(pd.accountNumber || "");
      setIfscCode(pd.ifscCode || "");
      setAccountHolderName(pd.accountHolderName || "");
      setUpiId(pd.upiId || "");
    } else {
      // Reset to default values
      setPaymentMode("BANK");
      setBankName("");
      setAccountNumber("");
      setIfscCode("");
      setAccountHolderName("");
      setUpiId("");
    }
    setPaymentDetailsOpen(true);
  };

  const handlePaymentDetailsClose = () => {
    setPaymentDetailsOpen(false);
  };

  // Evaluation handlers
  const handleEvaluationOpen = () => setOpenEvaluation(true);
  const handleEvaluationClose = () => setOpenEvaluation(false);

  // Meeting handlers
  const handleMeetingClick = async () => {
    try {
      setLoadingMeeting(true);
      // Fetch existing meeting for tutor
      const response = await axios.get(`/meetings?tutorId=${id}`);
      const meetings = response.data?.meetings || [];
      const existingMeeting = meetings.length > 0 ? meetings[0] : null;

      setMeetingDialog({
        open: true,
        existingMeeting,
      });
      setHasMeeting(existingMeeting !== null);
    } catch (error) {
      console.error("Error fetching meeting:", error);
      // Open dialog anyway for creating new meeting
      setMeetingDialog({
        open: true,
        existingMeeting: null,
      });
    } finally {
      setLoadingMeeting(false);
    }
  };

  const handleCloseMeetingDialog = () => {
    setMeetingDialog({
      open: false,
      existingMeeting: null,
    });
  };

  const handleMeetingSuccess = (isUpdate = false) => {
    toast.success(isUpdate ? "Meeting updated successfully!" : "Meeting submitted successfully!");
    setHasMeeting(true);
  };

  const fetchEvaluation = async () => {
    try {
      const response = await axios.get(`${baseURL}/tutor-evaluations?tutorId=${id}`);
      if (response.data.success && response.data.data.length > 0) {
        const evalData = response.data.data[0];
        setEvaluation(evalData);

        // Map subjectRatings to use subjectId._id if populated
        const mappedSubjectRatings = (evalData.subjectRatings || []).map((sr) => ({
          subjectId: typeof sr.subjectId === "object" ? sr.subjectId._id : sr.subjectId,
          rating: sr.rating || 1,
        }));

        setEvaluationForm({
          introduction: evalData.introduction || 0,
          english: evalData.english || "BASIC",
          englishRating: evalData.englishRating || 1,
          hindiRating: evalData.hindiRating || 1,
          tonePitch: evalData.tonePitch || "MEDIUM",
          crossQuestions: evalData.crossQuestions || 1,
          subjectRatings: mappedSubjectRatings,
          startingFromBasics: evalData.teachingMethods?.startingFromBasics || false,
          smoothExplanations: evalData.teachingMethods?.smoothExplanations || false,
          lisp: evalData.lisp || false,
          lispCategory: evalData.lispCategory || "",
          remarks: evalData.remarks || "",
          confidenceLevel: evalData.confidenceLevel || 1,
          personalityWise: evalData.personalityWise || "",
        });
      }
    } catch (error) {
      console.error("Error fetching evaluation:", error);
    }
  };

  const handleEvaluationSubmit = async () => {
    try {
      setSavingEvaluation(true);

      // Filter out incomplete subject ratings (only include entries with valid subjectId)
      const validSubjectRatings = evaluationForm.subjectRatings.filter(
        (sr) => sr.subjectId && sr.subjectId.trim() !== ""
      );

      const payload = {
        introduction: evaluationForm.introduction,
        english: evaluationForm.english,
        englishRating: evaluationForm.englishRating,
        hindiRating: evaluationForm.hindiRating,
        tonePitch: evaluationForm.tonePitch,
        crossQuestions: evaluationForm.crossQuestions,
        subjectRatings: validSubjectRatings,
        teachingMethods: {
          startingFromBasics: evaluationForm.startingFromBasics,
          smoothExplanations: evaluationForm.smoothExplanations,
        },
        lisp: evaluationForm.lisp,
        lispCategory: evaluationForm.lispCategory,
        remarks: evaluationForm.remarks,
        confidenceLevel: evaluationForm.confidenceLevel,
        personalityWise: evaluationForm.personalityWise,
      };

      const isNewEvaluation = !evaluation || !evaluation._id;

      if (evaluation && evaluation._id) {
        await axios.put(`${baseURL}/tutor-evaluations/${evaluation._id}`, payload);
        toast.success("Evaluation updated successfully!");
      } else {
        await axios.post(`${baseURL}/tutor-evaluations`, { ...payload, tutorId: id });
        toast.success("Evaluation created successfully!");
      }

      await fetchEvaluation();
      handleEvaluationClose();

      // Check if tutor onboarding is completed and open approval dialog
      // Only open approval dialog for NEW evaluations, not when editing
      if (isNewEvaluation && tutor?.onboardingStatus === "COMPLETED") {
        setOpenApprovalDialog(true);
      }
    } catch (error) {
      console.error("Error submitting evaluation:", error);
      toast.error(error.response?.data?.message || "Failed to save evaluation");
    } finally {
      setSavingEvaluation(false);
    }
  };

  // Handle Approval/Rejection
  const handleApprovalDialogOpen = () => {
    // Check if evaluation exists
    if (!evaluation || !evaluation._id) {
      toast.error("Please add tutor evaluation first!");
      return;
    }

    // Reset form with proper subject mapping
    const mappedPricing = (tutor?.levelBasedPricing || []).map((pricing) => ({
      level: pricing.level,
      hourlyRate: pricing.hourlyRate || 0,
      edushalaMargin: pricing.edushalaMargin || 0,
      subjects: pricing.subjects?.map((s) => (typeof s === "object" ? s._id : s)) || [],
      numberOfSessions: pricing.numberOfSessions || 0,
    }));

    setApprovalForm({
      approvalStatus: "",
      rejectionReason: "",
      badgeLevel: tutor?.tutorLevel || "",
      edushalaMargin: tutor?.edushalaMargin || "",
      levelBasedPricing: mappedPricing,
    });
    setOpenApprovalDialog(true);
  };

  const handleApprovalDialogClose = () => {
    setOpenApprovalDialog(false);
  };

  const handleApprovalSubmit = async () => {
    try {
      // Validate form
      if (!approvalForm.approvalStatus) {
        toast.error("Please select Approved or Rejected");
        return;
      }

      if (approvalForm.approvalStatus === "REJECTED" && !approvalForm.rejectionReason) {
        toast.error("Please provide rejection reason");
        return;
      }

      setApprovalLoading(true);

      const payload = {
        approvalStatus: approvalForm.approvalStatus,
      };

      if (approvalForm.approvalStatus === "APPROVED") {
        // Set badge based on level
        if (approvalForm.badgeLevel) {
          payload.tutorLevel = approvalForm.badgeLevel;
          // Auto-assign badge based on level
          const badgeMap = {
            "Level 1": ["VERIFIED"],
            "Level 2": ["VERIFIED", "EXPERIENCED"],
            "Level 3": ["VERIFIED", "EXPERIENCED", "HIGHLY_RATED"],
            "Level 4": ["VERIFIED", "TOP_TUTOR", "EXPERIENCED", "HIGHLY_RATED"],
          };
          payload.badgeEarned = badgeMap[approvalForm.badgeLevel] || [];
        }

        // Send level-based pricing if exists, else fallback to single values
        if (approvalForm.levelBasedPricing && approvalForm.levelBasedPricing.length > 0) {
          payload.levelBasedPricing = approvalForm.levelBasedPricing;
        } else {
          // Fallback to old single value fields
          if (approvalForm.edushalaMargin) {
            payload.edushalaMargin = Number(approvalForm.edushalaMargin);
          }
        }
      } else if (approvalForm.approvalStatus === "REJECTED") {
        payload.rejectionReason = approvalForm.rejectionReason;
        // Automatically set to current date
        payload.rejectedTillDate = new Date().toISOString();
      }

      await axios.post(`${baseURL}/tutor-evaluations/approve/${id}`, payload);

      toast.success(
        `Tutor ${
          approvalForm.approvalStatus === "APPROVED" ? "approved" : "rejected"
        } successfully!`
      );

      handleApprovalDialogClose();

      // Refresh tutor data
      const res = await axios.get(`${baseURL}/tutor?id=${id}`);
      setTutor(res.data.data);
    } catch (error) {
      console.error("Error approving/rejecting tutor:", error);
      toast.error(error.response?.data?.message || "Failed to update tutor status");
    } finally {
      setApprovalLoading(false);
    }
  };

  const toggleStatus = (item) => {
    if (statusSelected.includes(item)) {
      setStatusSelected(statusSelected.filter((i) => i !== item));
    } else {
      setStatusSelected([...statusSelected, item]);
    }
  };

  const { id } = useParams();
  console.log("Tutor ID from URL:", id);

  const [tutor, setTutor] = useState(null);
  const [allTutorSlots, setAllTutorSlots] = useState([]);
  const [availableTutorSlots, setAvailableTutorSlots] = useState([]);
  const [busyTutorSlotIds, setBusyTutorSlotIds] = useState([]);
  const [preferredTutorSlotIds, setPreferredTutorSlotIds] = useState([]);
  const [availableTutorSlotsLoading, setAvailableTutorSlotsLoading] = useState(false);
  const [availableTutorSlotsError, setAvailableTutorSlotsError] = useState("");
  const [slotEditorOpen, setSlotEditorOpen] = useState(false);
  const [editedTutorSlotIds, setEditedTutorSlotIds] = useState([]);
  const [slotEditorSaving, setSlotEditorSaving] = useState(false);
  const [addTutorSlotOpen, setAddTutorSlotOpen] = useState(false);
  const [newTutorSlotStartTime, setNewTutorSlotStartTime] = useState("");
  const [newTutorSlotEndTime, setNewTutorSlotEndTime] = useState("");
  const [addTutorSlotSaving, setAddTutorSlotSaving] = useState(false);
  const [tutorSlotsRefreshKey, setTutorSlotsRefreshKey] = useState(0);
  const [registrationFeeWaiver, setRegistrationFeeWaiver] = useState(false);
  const [registrationFeeWaiverLoading, setRegistrationFeeWaiverLoading] = useState(false);

  const handleRegistrationFeeWaiverToggle = async (event) => {
    const nextWaiver = event.target.checked;
    const previousWaiver = Boolean(registrationFeeWaiver);

    // Never allow waiver updates once fee is already paid.
    if (tutor?.registrationFee) {
      return;
    }

    setRegistrationFeeWaiver(nextWaiver);
    setRegistrationFeeWaiverLoading(true);

    try {
      const formData = new FormData();
      formData.append("registrationFeeWaiver", String(nextWaiver));

      const response = await axios.put(`${baseURL}/tutor/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (!response.data?.success) {
        throw new Error("Fee waiver update failed");
      }

      const tutorRes = await axios.get(`${baseURL}/tutor?id=${id}`);
      setTutor(tutorRes.data.data);
      setDataRefreshKey((prev) => prev + 1);

      toast.success(
        nextWaiver ? "Fee waiver enabled successfully" : "Fee waiver disabled successfully"
      );
    } catch (err) {
      setRegistrationFeeWaiver(previousWaiver);
      toast.error(err.response?.data?.message || "Failed to update fee waiver");
      console.error("Error updating fee waiver:", err);
    } finally {
      setRegistrationFeeWaiverLoading(false);
    }
  };

  const handleTutorActiveStatusChange = async (event) => {
    const nextActive = event.target.value === "Active";
    const previousTutor = tutor;
    const previousAvailability = availability;

    setTutor((current) => (current ? { ...current, active: nextActive } : current));

    if (!nextActive) {
      setavailability("Not Available");
    }

    try {
      const response = await axios.patch(`${baseURL}/tutor/${id}/active-status`, {
        active: nextActive,
      });

      const updatedAvailability = response?.data?.data?.availability;

      if (updatedAvailability) {
        setavailability(updatedAvailability);
      }

      toast.success(`Tutor ${nextActive ? "activated" : "deactivated"} successfully!`);
    } catch (error) {
      setTutor(previousTutor);
      setavailability(previousAvailability);
      toast.error(error.response?.data?.message || "Failed to update tutor active status");
      console.error("Error updating tutor active status:", error);
    }
  };

  // Fetch meeting on component mount
  useEffect(() => {
    const fetchMeeting = async () => {
      try {
        const response = await axios.get(`/meetings?tutorId=${id}`);
        const meetings = response.data?.meetings || [];
        if (meetings.length > 0) {
          setHasMeeting(true);
        }
      } catch (error) {
        console.error("Error checking meeting:", error);
      }
    };
    if (id) {
      fetchMeeting();
    }
  }, [id]);

  useEffect(() => {
    axios
      .get(`${baseURL}/tutor?id=${id}`)
      .then((res) => {
        console.log("Tutor Details API Response:", res.data);
        setTutor(res.data.data);
      })
      .catch((err) => {
        console.error("Error fetching tutor details:", err);
      });

    // Fetch evaluation data
    fetchEvaluation();
  }, [id]);

  useEffect(() => {
    const fetchAvailableTutorSlots = async () => {
      if (!id) return;

      setAvailableTutorSlotsLoading(true);
      setAvailableTutorSlotsError("");

      try {
        const slotsRequest = axios.get("/slots", {
          params: {
            page: 1,
            limit: 100,
            sort: "startTime",
            order: "asc",
          },
        });
        const activeSessionsRequest = axios.get(`/classes/get/active/classesFor/tutor/${id}`, {
          params: { status: "ACTIVE" },
        });
        const tutorRequest = axios.get("/tutor", {
          params: { id },
        });

        const [slotsResponse, activeSessionsResponse, tutorResponse] = await Promise.all([
          slotsRequest,
          activeSessionsRequest,
          tutorRequest,
        ]);

        let allSlots = normalizeTutorSlots(slotsResponse);
        const totalPages = Number(
          slotsResponse?.data?.data?.pagination?.totalPages ||
            slotsResponse?.data?.data?.pagination?.total_page ||
            1
        );

        if (totalPages > 1) {
          const remainingPageRequests = [];
          for (let page = 2; page <= totalPages; page += 1) {
            remainingPageRequests.push(
              axios.get("/slots", {
                params: {
                  page,
                  limit: 100,
                  sort: "startTime",
                  order: "asc",
                },
              })
            );
          }

          const remainingPageResponses = await Promise.all(remainingPageRequests);
          remainingPageResponses.forEach((response) => {
            allSlots = [...allSlots, ...normalizeTutorSlots(response)];
          });
        }

        const activeSessions = Array.isArray(activeSessionsResponse?.data?.classes)
          ? activeSessionsResponse.data.classes
          : Array.isArray(activeSessionsResponse?.data?.data?.classes)
          ? activeSessionsResponse.data.data.classes
          : Array.isArray(activeSessionsResponse?.data?.data)
          ? activeSessionsResponse.data.data
          : [];
        const busySlotIds = new Set(
          activeSessions
            .map((session) => getTutorSlotId(session?.finalisedActiveSlot))
            .filter(Boolean)
            .map(String)
        );
        setBusyTutorSlotIds([...busySlotIds]);

        const tutorData =
          tutorResponse?.data?.data?.tutor ||
          tutorResponse?.data?.data ||
          tutorResponse?.data?.tutor ||
          null;
        const preferredSlotIds = new Set(
          (Array.isArray(tutorData?.preferredTeachingSlots) ? tutorData.preferredTeachingSlots : [])
            .map(getTutorSlotId)
            .filter(Boolean)
            .map(String)
        );
        setPreferredTutorSlotIds([...preferredSlotIds]);

        const uniqueSlots = new Map();
        allSlots.forEach((slot) => {
          const slotId = getTutorSlotId(slot);
          if (slotId && !slot?.isDeleted) {
            uniqueSlots.set(String(slotId), slot);
          }
        });
        const sortedTutorSlots = Array.from(uniqueSlots.values()).sort((a, b) =>
          getTutorSlotLabel(a).localeCompare(getTutorSlotLabel(b))
        );
        setAllTutorSlots(sortedTutorSlots);

        const availableSlots = sortedTutorSlots
          .filter((slot) => {
            const slotId = String(getTutorSlotId(slot));
            if (busySlotIds.has(slotId)) return false;
            if (preferredSlotIds.size > 0) return preferredSlotIds.has(slotId);
            return true;
          })
          .sort((a, b) => getTutorSlotLabel(a).localeCompare(getTutorSlotLabel(b)));

        setAvailableTutorSlots(availableSlots);
      } catch (error) {
        console.error("Error fetching available tutor slots:", error);
        setAllTutorSlots([]);
        setAvailableTutorSlots([]);
        setBusyTutorSlotIds([]);
        setPreferredTutorSlotIds([]);
        setAvailableTutorSlotsError(
          error.response?.data?.message ||
            error.response?.data?.error ||
            "Failed to load available slots"
        );
      } finally {
        setAvailableTutorSlotsLoading(false);
      }
    };

    fetchAvailableTutorSlots();
  }, [id, tutorSlotsRefreshKey]);

  const handleOpenTutorSlotEditor = () => {
    const busySet = new Set(busyTutorSlotIds.map(String));
    const freeSlotIds = allTutorSlots
      .map((slot) => String(getTutorSlotId(slot)))
      .filter((slotId) => slotId && !busySet.has(slotId));
    const selectedFreeSlotIds =
      preferredTutorSlotIds.length > 0
        ? preferredTutorSlotIds.filter((slotId) => !busySet.has(String(slotId)))
        : freeSlotIds;

    setEditedTutorSlotIds(selectedFreeSlotIds.map(String));
    setSlotEditorOpen(true);
  };

  const handleToggleTutorSlot = (slotId) => {
    const normalizedSlotId = String(slotId);
    if (busyTutorSlotIds.map(String).includes(normalizedSlotId)) return;

    setEditedTutorSlotIds((current) =>
      current.includes(normalizedSlotId)
        ? current.filter((idToKeep) => idToKeep !== normalizedSlotId)
        : [...current, normalizedSlotId]
    );
  };

  const handleSaveTutorSlots = async () => {
    if (editedTutorSlotIds.length === 0) {
      toast.error("Please select at least one available slot");
      return;
    }

    setSlotEditorSaving(true);
    try {
      const busySet = new Set(busyTutorSlotIds.map(String));
      const busyPreferredIds = preferredTutorSlotIds
        .map(String)
        .filter((slotId) => busySet.has(slotId));
      const preferredTeachingSlots = [
        ...new Set([...busyPreferredIds, ...editedTutorSlotIds.map(String)]),
      ];

      await axios.put(`${baseURL}/tutor/${id}`, {
        preferredTeachingSlots,
      });

      setSlotEditorOpen(false);
      setTutorSlotsRefreshKey((current) => current + 1);
      const tutorResponse = await axios.get(`${baseURL}/tutor?id=${id}`);
      setTutor(tutorResponse.data.data);
      toast.success("Tutor slots updated successfully");
    } catch (error) {
      console.error("Error updating tutor slots:", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to update tutor slots"
      );
    } finally {
      setSlotEditorSaving(false);
    }
  };

  const handleCloseAddTutorSlot = () => {
    if (addTutorSlotSaving) return;
    setAddTutorSlotOpen(false);
    setNewTutorSlotStartTime("");
    setNewTutorSlotEndTime("");
  };

  const handleAddTutorSlot = async (event) => {
    event.preventDefault();

    if (!newTutorSlotStartTime || !newTutorSlotEndTime) {
      toast.error("Start time and end time are required");
      return;
    }

    setAddTutorSlotSaving(true);
    try {
      const slotResponse = await axios.post(`${baseURL}/slots`, {
        startTime: newTutorSlotStartTime,
        endTime: newTutorSlotEndTime,
      });
      const newSlot = slotResponse?.data?.data;
      const newSlotId = getTutorSlotId(newSlot);

      // An empty preference list means all free slots are available. When preferences
      // are explicit, append the newly created slot so it is available for this tutor.
      if (newSlotId && preferredTutorSlotIds.length > 0) {
        await axios.put(`${baseURL}/tutor/${id}`, {
          preferredTeachingSlots: [
            ...new Set([...preferredTutorSlotIds.map(String), String(newSlotId)]),
          ],
        });
      }

      setAddTutorSlotOpen(false);
      setNewTutorSlotStartTime("");
      setNewTutorSlotEndTime("");
      setTutorSlotsRefreshKey((current) => current + 1);
      toast.success("Slot added successfully");
    } catch (error) {
      console.error("Error adding tutor slot:", error);
      toast.error(
        error.response?.data?.message || error.response?.data?.error || "Failed to add slot"
      );
    } finally {
      setAddTutorSlotSaving(false);
    }
  };

  console.log("Tutor Details:", tutor);

  useEffect(() => {
    if (tutor) {
      setRegistrationFeeWaiver(Boolean(tutor.registrationFeeWaiver));
      setFullName(tutor.fullName || "");
      setEmail(tutor.email || "");
      // Set subjects as array of IDs
      setSubjects(tutor.subjects?.map((subj) => subj._id) || []);
      setPhone(tutor.phone || "");
      setAlternateMobile(tutor.alternateMobile || "");
      // Get address from locationPreference if available
      const locationPrefAddress = tutor.locationPreference?.find((loc) => loc.address)?.address;
      setAddress(
        locationPrefAddress ||
          tutor.permanentAddress ||
          tutor.address ||
          tutor.generatedMapAddress ||
          tutor.currentAddress ||
          ""
      );
      setAbout(tutor.about || "");
      setExperience(tutor.experience ?? "");
      setDescription(tutor.description || "");
      // setCityAddress(tutor.permanentAddress || ""); // response mai cityAddress nahi, permanentAddress use kiya
      // setStateName(tutor.locationPreference?.[0]?.state || ""); // state fetch from locationPreference
      setLevel(tutor.tutorLevel || "");
      setGender(tutor.gender || "");
      // Format dob for date input (YYYY-MM-DD)
      setDob(tutor.dob ? new Date(tutor.dob).toISOString().split("T")[0] : "");
      setReferralCode(tutor.referral || "");
      setavailability(tutor.availability || "");
      setReviewsCount(tutor.reviewsCount || 0);
      setAverageRating(tutor.averageRating || 0);

      // Set teaching preferences
      if (tutor.subjects?.length > 0 || tutor.boards?.length > 0 || tutor.classes?.length > 0) {
        // Convert parallel array data to preference objects for editing
        const maxLength = Math.max(
          tutor.subjects?.length || 0,
          tutor.boards?.length || 0,
          tutor.classes?.length || 0
        );

        const preferences = [];
        for (let i = 0; i < maxLength; i++) {
          preferences.push({
            subject: tutor.subjects?.[i] ? { _id: tutor.subjects[i]._id } : undefined,
            board: tutor.boards?.[i] ? { _id: tutor.boards[i]._id } : undefined,
            class: tutor.classes?.[i] ? { _id: tutor.classes[i]._id } : undefined,
          });
        }
        setTeachingPreferences(preferences);
      } else {
        // If no existing preferences, initialize with sensible defaults from dropdown options
        const defaultPref = {};
        if (allSubjects && allSubjects.length > 0)
          defaultPref.subject = { _id: allSubjects[0].value };
        if (allBoards && allBoards.length > 0) defaultPref.board = { _id: allBoards[0].value };
        if (allClasses && allClasses.length > 0) defaultPref.class = { _id: allClasses[0].value };
        setTeachingPreferences([defaultPref]);
      }

      // Set educational qualifications
      console.log("🎓 Raw Education Qualifications from API:", tutor.educationQualification);
      if (tutor.educationQualification && tutor.educationQualification.length > 0) {
        tutor.educationQualification.forEach((qual, idx) => {
          console.log(`Qualification ${idx + 1} - Medium:`, qual.medium);
        });
      }
      setEduQualifications(tutor.educationQualification || []);

      // Set educational qualification marksheet previews
      const marksheetPreviews = {};
      const marksheetFiles = {};
      (tutor.educationQualification || []).forEach((qual, index) => {
        if (qual.marksheet) {
          marksheetPreviews[index] = qual.marksheet;
        }
        // Always initialize as empty array, even if no existing marksheet
        marksheetFiles[index] = [];
      });
      setEduQualMarksheetPreviews(marksheetPreviews);
      setEduQualMarksheetFiles(marksheetFiles);

      console.log("Initialized marksheet files:", marksheetFiles);
      console.log("Initialized marksheet previews:", marksheetPreviews);

      // Set location preferences
      setLocationPreferences(tutor.locationPreference || []);

      // Set teaching experience (backend field: professionalExperience)
      setTeachingExperience(tutor.professionalExperience || tutor.teachingExperience || []);

      // Set Aadhaar document previews
      setAadhaarFrontPreview(tutor.aadhaarDocument?.frontImage || null);
      setAadhaarBackPreview(tutor.aadhaarDocument?.backImage || null);

      // Set additional fields
      setExperiencePoints(tutor.experiencePoints || []);
      setEducationPoints(tutor.educationPoints || []);
    }
  }, [tutor]);

  // Update marksheet states when eduQualifications change
  useEffect(() => {
    if (eduQualOpen) {
      const marksheetPreviews = { ...eduQualMarksheetPreviews };
      const marksheetFiles = { ...eduQualMarksheetFiles };

      // Ensure all qualifications have entries in the marksheet states
      eduQualifications.forEach((qual, index) => {
        if (!(index in marksheetFiles)) {
          marksheetFiles[index] = [];
        }
        if (!(index in marksheetPreviews) && qual.marksheet) {
          marksheetPreviews[index] = qual.marksheet;
        }
      });

      setEduQualMarksheetPreviews(marksheetPreviews);
      setEduQualMarksheetFiles(marksheetFiles);
    }
  }, [eduQualifications, eduQualOpen]);

  const handleUpdateTutor = async (e) => {
    e.preventDefault();
    setUpdateLoading(true);

    // Validate alternate mobile number
    if (alternateMobile && (alternateMobile.length !== 10 || !/^\d+$/.test(alternateMobile))) {
      toast.error("Alternate mobile must be 10 digits");
      setUpdateLoading(false);
      return;
    }

    try {
      // Create FormData for file uploads
      const formData = new FormData();

      // Add text fields
      formData.append("fullName", fullName);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("alternateMobile", alternateMobile);
      formData.append("permanentAddress", address.trim());
      formData.append("about", about.trim());
      formData.append("description", description.trim());
      // formData.append("permanentAddress", cityAddress);
      formData.append("gender", gender);
      if (dob) {
        formData.append("dob", dob);
      }

      if (experience !== "" && experience !== null && experience !== undefined) {
        formData.append("experience", experience);
      }

      // Add tutor level if selected
      if (level) {
        formData.append("tutorLevel", level);
      }

      // Add referral code if provided
      if (referralCode.trim()) {
        formData.append("referral", referralCode);
      }

      // Add availability
      if (availability) {
        formData.append("availability", availability);
      }

      // Fee waiver toggle (admin-side flag to skip registration fee flow)
      formData.append("registrationFeeWaiver", String(registrationFeeWaiver));

      // Add reviews data
      formData.append("reviewsCount", reviewsCount);
      formData.append("averageRating", averageRating);

      // Add subjects as JSON array
      const subjectsArray = Array.isArray(subjects) ? subjects : subjects ? [subjects] : [];
      subjectsArray.forEach((subj, index) => {
        formData.append(`subjects[${index}]`, subj);
      });

      // Add location preference
      // formData.append("locationPreference[0][state]", stateName);

      // Add new fields
      experiencePoints.forEach((point) => {
        formData.append("experiencePoints[]", point);
      });
      educationPoints.forEach((point) => {
        formData.append("educationPoints[]", point);
      });

      // Add Aadhaar Front Image if new file is selected
      if (aadhaarFrontFiles.length > 0 && aadhaarFrontFiles[0].file) {
        formData.append("aadhaarFrontImage", aadhaarFrontFiles[0].file);
      }

      // Add Aadhaar Back Image if new file is selected
      if (aadhaarBackFiles.length > 0 && aadhaarBackFiles[0].file) {
        formData.append("aadhaarBackImage", aadhaarBackFiles[0].file);
      }

      const res = await axios.put(`${baseURL}/tutor/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        // Refresh tutor data
        const tutorRes = await axios.get(`${baseURL}/tutor?id=${id}`);
        setTutor(tutorRes.data.data);
        // Force refresh of all table components
        setDataRefreshKey((prev) => prev + 1);
        setRefreshTeachingPref((prev) => !prev);

        // Clear file states
        setAadhaarFrontFiles([]);
        setAadhaarBackFiles([]);

        toast.success("Tutor details updated successfully!");
        handleClose();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update tutor details");
      console.error("Error updating tutor:", err);
      console.error("Error response:", err.response?.data);
    } finally {
      setUpdateLoading(false);
    }
  };

  const handleUpdateTeachingPreferences = (e) => {
    e.preventDefault();
    setTeachingPrefLoading(true);

    // Extract all subjects and boards from preferences
    const allSelectedSubjects = [];
    const allSelectedBoards = [];
    const allSelectedClasses = [];

    teachingPreferences.forEach((pref) => {
      // Add subjects
      if (pref.subjects && Array.isArray(pref.subjects)) {
        pref.subjects.forEach((subj) => {
          if (subj._id && !allSelectedSubjects.includes(subj._id)) {
            allSelectedSubjects.push(subj._id);
          }
        });
      }
      // Add boards
      if (pref.boards && Array.isArray(pref.boards)) {
        pref.boards.forEach((board) => {
          if (board._id && !allSelectedBoards.includes(board._id)) {
            allSelectedBoards.push(board._id);
          }
        });
      }
      // Add class
      if (pref.class?._id && !allSelectedClasses.includes(pref.class._id)) {
        allSelectedClasses.push(pref.class._id);
      }
    });

    const payload = {
      subjects: allSelectedSubjects,
      boards: allSelectedBoards,
      classes: allSelectedClasses,
    };

    axios
      .put(`${baseURL}/tutor/${id}`, payload)
      .then((res) => {
        if (res.data.success) {
          // Refresh tutor data
          axios.get(`${baseURL}/tutor?id=${id}`).then((res) => {
            setTutor(res.data.data);
            // Force refresh of all table components
            setDataRefreshKey((prev) => prev + 1);
          });

          // Trigger refresh for teaching preferences table
          setRefreshTeachingPref((prev) => !prev);

          toast.success("Teaching preferences updated successfully!");
          handleTeachingPrefClose();
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to update teaching preferences");
        console.error("Error updating teaching preferences:", err);
      })
      .finally(() => {
        setTeachingPrefLoading(false);
      });
  };

  const isBoardMediumQualificationName = (name) =>
    /\b(12th|12|xii|twelfth)\b/i.test((name || "").toString().trim());

  const getQualificationName = (qualification) => {
    const qualificationId = qualification?.class?._id || qualification?.class || "";
    const fromList = allQualifications.find((item) => item.value === qualificationId)?.label;
    return fromList || qualification?.class?.name || "";
  };

  const isBoardMediumApplicable = (qualification) =>
    isBoardMediumQualificationName(getQualificationName(qualification));

  const handleUpdateEducationalQualifications = async (e) => {
    e.preventDefault();
    setEduQualLoading(true);

    try {
      // Separate existing and new qualifications
      const existingQualifications = eduQualifications.filter((qual) => qual?._id);
      const newQualifications = eduQualifications.filter((qual) => !qual?._id);

      // Update existing qualifications
      const updatePromises = existingQualifications.map(async (qual) => {
        // Get the index in the original eduQualifications array
        const index = eduQualifications.indexOf(qual);

        const formData = new FormData();

        // Extract IDs properly - backend expects ObjectId strings
        const classId = qual?.class?._id || qual?.class || "";
        const boardId = qual?.board?._id || qual?.board || "";
        const boardMediumApplicable = isBoardMediumApplicable(qual);

        // Get year - check both field names and ensure it's a valid number
        const yearValue = qual?.completedYear || qual?.yearOfCompletion || "";
        const completedYear = yearValue ? parseInt(yearValue, 10) : new Date().getFullYear();

        // Get school/university name - check both field names
        const schoolUniversity = qual?.schoolUniversity || qual?.schoolUniversityCollege || "";

        console.log(`📝 Updating qualification ${qual._id}:`, {
          classId,
          boardId,
          completedYear,
          schoolUniversity,
          tutorId: id,
        });

        // Append data to FormData
        formData.append("class", classId);
        if (boardMediumApplicable && boardId) {
          formData.append("board", boardId);
        }
        if (boardMediumApplicable && qual?.medium) {
          formData.append("medium", qual.medium);
        }
        formData.append("completedYear", completedYear.toString());
        formData.append("schoolUniversity", schoolUniversity);
        formData.append("tutor", id);

        // Handle marksheet file
        if (eduQualMarksheetFiles[index] && eduQualMarksheetFiles[index].length > 0) {
          formData.append("marksheet", eduQualMarksheetFiles[index][0].file);
        }

        return axios.put(`${baseURL}/education-qualifications/${qual._id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      });

      // Create new qualifications
      const createPromises = newQualifications.map(async (qual) => {
        // Get the index in the original eduQualifications array
        const index = eduQualifications.indexOf(qual);

        const formData = new FormData();

        // Extract IDs properly - backend expects ObjectId strings
        const classId = qual?.class?._id || qual?.class || "";
        const boardId = qual?.board?._id || qual?.board || "";
        const boardMediumApplicable = isBoardMediumApplicable(qual);

        // Get year - check both field names and ensure it's a valid number
        const yearValue = qual?.completedYear || qual?.yearOfCompletion || "";
        const completedYear = yearValue ? parseInt(yearValue, 10) : new Date().getFullYear();

        // Get school/university name - check both field names
        const schoolUniversity = qual?.schoolUniversity || qual?.schoolUniversityCollege || "";

        console.log(`➕ Creating new qualification:`, {
          classId,
          boardId,
          completedYear,
          schoolUniversity,
          tutorId: id,
        });

        // Append data to FormData
        formData.append("class", classId);
        if (boardMediumApplicable && boardId) {
          formData.append("board", boardId);
        }
        if (boardMediumApplicable && qual?.medium) {
          formData.append("medium", qual.medium);
        }
        formData.append("completedYear", completedYear.toString());
        formData.append("schoolUniversity", schoolUniversity);
        formData.append("tutor", id);

        // Handle marksheet file
        if (eduQualMarksheetFiles[index] && eduQualMarksheetFiles[index].length > 0) {
          formData.append("marksheet", eduQualMarksheetFiles[index][0].file);
        }

        return axios.post(`${baseURL}/education-qualifications`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      });

      // Wait for all operations to complete
      const [updateResults, createResults] = await Promise.all([
        Promise.all(updatePromises),
        Promise.all(createPromises),
      ]);

      console.log(
        "✅ All qualifications updated:",
        updateResults.map((r) => r.data)
      );
      console.log(
        "✅ All new qualifications created:",
        createResults.map((r) => r.data)
      );

      // Refresh tutor data
      const tutorResponse = await axios.get(`${baseURL}/tutor?id=${id}`);
      setTutor(tutorResponse.data.data);
      setDataRefreshKey((prev) => prev + 1);

      toast.success("Educational qualifications updated successfully!");
      handleEduQualClose();
    } catch (err) {
      const errorMsg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        "Failed to update educational qualifications";
      toast.error(errorMsg);
      console.error("❌ Error updating educational qualifications:", err);
      console.error("Error response:", err.response?.data);
      console.error("Error details:", {
        status: err.response?.status,
        data: err.response?.data,
        config: err.config?.data,
      });
    } finally {
      setEduQualLoading(false);
    }
  };

  const handleUpdateLocationPreferences = (e) => {
    e.preventDefault();
    setLocationPrefLoading(true);

    // Format the location preferences properly for API
    // Backend accepts: address1, address2, city, state, pinCode, landMark, latitude, longitude
    const formattedLocations = locationPreferences
      .map((location) => {
        // Preserve all existing fields except _id
        const { _id, ...rest } = location;
        const formatted = {
          ...rest, // Keep all existing fields except _id
          addressLine1: location?.addressLine1 || location?.address1 || "",
          address1: location?.addressLine1 || location?.address1 || "",
          lat: location?.lat || undefined,
          lng: location?.lng || undefined,
        };

        // Clean up undefined values
        Object.keys(formatted).forEach((key) => {
          if (formatted[key] === undefined || formatted[key] === "") {
            delete formatted[key];
          }
        });

        return formatted;
      })
      .filter(
        (location) => location.addressLine1 || location.address1 || location.lat || location.lng
      );

    const payload = {
      locationPreference: formattedLocations,
    };

    console.log("Location Preference Payload:", payload);

    axios
      .put(`${baseURL}/tutor/${id}`, payload)
      .then((res) => {
        console.log("Location API Response:", res.data);
        if (res.data.success) {
          axios.get(`${baseURL}/tutor?id=${id}`).then((res) => {
            setTutor(res.data.data);
            setDataRefreshKey((prev) => prev + 1);
          });

          toast.success("Location preferences updated successfully!");
          handleLocationPrefClose();
        }
      })
      .catch((err) => {
        const errorMsg =
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Failed to update location preferences";
        toast.error(errorMsg);
        console.error("Error updating location preferences:", err);
        console.error("Error response:", err.response?.data);
      })
      .finally(() => {
        setLocationPrefLoading(false);
      });
  };

  const handleUpdateTeachingExperience = (e) => {
    e.preventDefault();
    setTeachingExpLoading(true);

    // Format the teaching experience properly for API
    // Backend expects: professionalExperience with organization, position, startDate, endDate, etc.
    const formattedExperience = teachingExperience
      .map((exp) => {
        // Map frontend fields to backend fields
        const organization = exp?.organization || exp?.institutionOrganization || "";
        const position = exp?.position || exp?.positionRole || "";
        const startDate = exp?.startDate || (exp?.duration ? new Date().toISOString() : "");
        const endDate = exp?.endDate || "";
        const isCurrentlyWorking = exp?.isCurrentlyWorking || false;
        const description = exp?.description || exp?.subjectTaught || "";
        const experienceType = exp?.experienceType || "TEACHING";
        const classes = exp?.classes?.map((cls) => cls._id || cls) || undefined;
        const boards = exp?.boards?.map((board) => board._id || board) || undefined;
        const subjects = exp?.subjects?.map((subject) => subject._id || subject) || undefined;

        console.log(`📝 Formatting experience:`, {
          organization,
          position,
          startDate,
          endDate,
          isCurrentlyWorking,
          description,
          experienceType,
          classes,
          boards,
          subjects,
        });

        return {
          organization,
          position,
          startDate,
          endDate: endDate || undefined,
          isCurrentlyWorking,
          description,
          experienceType,
          classes,
          boards,
          subjects,
        };
      })
      .filter((exp) => exp.organization && exp.position && exp.startDate); // Required fields check

    // Remove undefined values
    const cleanedExperience = formattedExperience.map((exp) => {
      const cleaned = {};
      Object.keys(exp).forEach((key) => {
        if (exp[key] !== undefined && exp[key] !== "") {
          cleaned[key] = exp[key];
        }
      });
      return cleaned;
    });

    const payload = {
      professionalExperience: cleanedExperience, // Backend field name
    };

    console.log("Teaching Experience Payload:", payload);

    axios
      .put(`${baseURL}/tutor/${id}`, payload)
      .then((res) => {
        console.log("Teaching Experience API Response:", res.data);
        if (res.data.success) {
          axios.get(`${baseURL}/tutor?id=${id}`).then((res) => {
            setTutor(res.data.data);
            setDataRefreshKey((prev) => prev + 1);
          });

          toast.success("Teaching experience updated successfully!");
          handleTeachingExpClose();
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to update teaching experience");
        console.error("Error updating teaching experience:", err);
        console.error("Error response:", err.response?.data);
      })
      .finally(() => {
        setTeachingExpLoading(false);
      });
  };

  const handleUpdateCertificates = async (e) => {
    e.preventDefault();
    setCertificateLoading(true);

    try {
      // Validate all certificates have name
      const hasInvalidCert = certificates.some((cert) => !cert.certificateName?.trim());
      if (hasInvalidCert) {
        toast.error("Please fill certificate name for all certificates");
        setCertificateLoading(false);
        return;
      }

      // Filter out empty certificates
      const validCertificates = certificates.filter((cert) => cert.certificateName?.trim());

      if (validCertificates.length === 0) {
        toast.error("Please add at least one certificate");
        setCertificateLoading(false);
        return;
      }

      // Create FormData for file upload
      const formData = new FormData();

      // Prepare certificates metadata
      const certificatesMetadata = validCertificates.map((cert) => ({
        ...(cert._id && { _id: cert._id }),
        certificateName: cert.certificateName.trim(),
        ...(cert.certificateImage &&
          !cert.certificateFile && { certificateImage: cert.certificateImage }),
        ...(cert.certificateFile && { needsUpload: true }),
      }));

      // Add certificates metadata as JSON string
      formData.append("certificates", JSON.stringify(certificatesMetadata));

      // Add certificate files (only new uploads)
      validCertificates.forEach((cert) => {
        if (cert.certificateFile) {
          formData.append("certificateImage", cert.certificateFile);
        }
      });

      console.log("Certificates FormData prepared with", validCertificates.length, "certificates");

      const response = await axios.put(`${baseURL}/tutor/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        const tutorRes = await axios.get(`${baseURL}/tutor?id=${id}`);
        setTutor(tutorRes.data.data);
        setDataRefreshKey((prev) => prev + 1);

        toast.success("Certificates updated successfully!");
        handleCertificateClose();
      }
    } catch (err) {
      const errorMsg =
        err.response?.data?.message || err.response?.data?.error || "Failed to update certificates";
      toast.error(errorMsg);
      console.error("Error updating certificates:", err);
      console.error("Error response:", err.response?.data);
    } finally {
      setCertificateLoading(false);
    }
  };

  const handleUpdatePaymentDetails = async (e) => {
    e.preventDefault();
    setPaymentDetailsLoading(true);

    try {
      // Validation
      if (!paymentMode) {
        toast.error("Please select payment mode");
        setPaymentDetailsLoading(false);
        return;
      }

      if (paymentMode === "BANK") {
        if (
          !bankName.trim() ||
          !accountNumber.trim() ||
          !ifscCode.trim() ||
          !accountHolderName.trim()
        ) {
          toast.error("Please fill all bank details");
          setPaymentDetailsLoading(false);
          return;
        }

        // Validate IFSC code format
        const ifscPattern = /^[A-Z]{4}0[A-Z0-9]{6}$/;
        if (!ifscPattern.test(ifscCode.trim())) {
          toast.error("Invalid IFSC code format. Must be 11 characters (e.g., HDFC0001234)");
          setPaymentDetailsLoading(false);
          return;
        }

        // Validate account number (9-18 digits)
        const accountPattern = /^[0-9]{9,18}$/;
        if (!accountPattern.test(accountNumber.trim())) {
          toast.error("Account number must be 9-18 digits");
          setPaymentDetailsLoading(false);
          return;
        }
      } else if (paymentMode === "UPI") {
        if (!upiId.trim()) {
          toast.error("Please enter UPI ID");
          setPaymentDetailsLoading(false);
          return;
        }
      }

      const payload = {
        mode: paymentMode,
      };

      if (paymentMode === "BANK") {
        payload.bankName = bankName.trim();
        payload.accountNumber = accountNumber.trim();
        payload.ifscCode = ifscCode.trim().toUpperCase();
        payload.accountHolderName = accountHolderName.trim();
      } else if (paymentMode === "UPI") {
        payload.upiId = upiId.trim().toLowerCase();
      }

      console.log("Payment Details Payload:", payload);

      const response = await axios.post(`${baseURL}/tutor/${id}/payment-details`, payload);

      if (response.data.success) {
        const tutorRes = await axios.get(`${baseURL}/tutor?id=${id}`);
        setTutor(tutorRes.data.data);
        setDataRefreshKey((prev) => prev + 1);

        toast.success("Payment details updated successfully!");
        handlePaymentDetailsClose();
      }
    } catch (err) {
      const errorMsg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Failed to update payment details";
      toast.error(errorMsg);
      console.error("Error updating payment details:", err);
      console.error("Error response:", err.response?.data);
    } finally {
      setPaymentDetailsLoading(false);
    }
  };

  //  const {id} = useParams();
  // All table data now uses tutor object directly (no more separate API calls)
  const { columns, rows } = TeachingPreferenceTableData(tutor);
  const { columns1, rows1 } = EducationalQualificationTableData(tutor);
  const { columns2, rows2 } = LocationPreferenceTableData(tutor);
  const { columns3, rows3 } = TeachingExperienceTableData(tutor);
  const { columns: columns4, rows: rows4 } = CertificateTableData(tutor);
  const { columns: columns6, rows: rows6 } = AdditionalDocumentsTableData(tutor);
  const { columns: columns5, rows: rows5 } = PaymentDetailsTableData(tutor);

  return (
    <ArgonBox>
      {/* <TutoProfileCard/> */}
      <ArgonBox>
        <Grid container mt={2} spacing={2}>
          {/* Profile Header with Image */}
          <Grid item xs={12}>
            <Card
              sx={{
                borderRadius: 2,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
                p: 2,
              }}
            >
              <ArgonBox display="flex" alignItems="center" justifyContent="space-between">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <Avatar
                    src={tutor?.profileImage || ""}
                    alt={tutor?.fullName || "Tutor Image"}
                    onClick={() => {
                      if (tutor?.profileImage) {
                        setSelectedImage(tutor?.profileImage);
                        setImageModalOpen(true);
                      } else {
                        toast.info("No profile image available");
                      }
                    }}
                    sx={{
                      width: 70,
                      height: 70,
                      border: "3px solid white",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                      cursor: "pointer",
                    }}
                  />
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="bold" color="white" mb={1}>
                      {tutor?.fullName}
                    </ArgonTypography>
                    <ArgonBox display="flex" flexDirection="column" gap={0.5}>
                      <ArgonBox display="flex" alignItems="center" gap={1}>
                        <ArgonBox
                          sx={{
                            backgroundColor: "rgba(255,255,255,0.2)",
                            borderRadius: "8px",
                            padding: "4px 12px",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <ArgonTypography variant="caption" color="white" fontWeight="bold">
                            📞
                          </ArgonTypography>
                          <ArgonTypography variant="caption" color="white" fontWeight="medium">
                            {tutor?.phone || "N/A"}
                          </ArgonTypography>
                        </ArgonBox>
                        <ArgonBox
                          sx={{
                            backgroundColor: "rgba(255,255,255,0.2)",
                            borderRadius: "8px",
                            padding: "4px 12px",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <ArgonTypography variant="caption" color="white" fontWeight="bold">
                            ✉️
                          </ArgonTypography>
                          <ArgonTypography variant="caption" color="white" fontWeight="medium">
                            {tutor?.email || "N/A"}
                          </ArgonTypography>
                        </ArgonBox>
                      </ArgonBox>
                      {(tutor?.address || tutor?.generatedMapAddress) && (
                        <ArgonBox display="flex" flexDirection="column" gap={0.5}>
                          {tutor?.address && (
                            <ArgonBox
                              sx={{
                                backgroundColor: "rgba(255,255,255,0.2)",
                                borderRadius: "8px",
                                padding: "4px 12px",
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                maxWidth: "600px",
                              }}
                            >
                              <ArgonTypography variant="caption" color="white" fontWeight="bold">
                                📍
                              </ArgonTypography>
                              <ArgonTypography variant="caption" color="white" fontWeight="medium">
                                {tutor?.address}
                              </ArgonTypography>
                            </ArgonBox>
                          )}
                          {tutor?.generatedMapAddress && (
                            <ArgonBox
                              sx={{
                                backgroundColor: "rgba(255,255,255,0.2)",
                                borderRadius: "8px",
                                padding: "4px 12px",
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                maxWidth: "600px",
                              }}
                            >
                              <ArgonTypography variant="caption" color="white" fontWeight="bold">
                                🗺️
                              </ArgonTypography>
                              <ArgonTypography
                                variant="caption"
                                color="white"
                                fontWeight="medium"
                                fontStyle="italic"
                              >
                                {tutor?.generatedMapAddress}
                              </ArgonTypography>
                            </ArgonBox>
                          )}
                        </ArgonBox>
                      )}
                    </ArgonBox>
                  </ArgonBox>
                </ArgonBox>

                <ArgonBox display="flex" flexDirection="column" alignItems="flex-end" gap={1}>
                  <ArgonBox
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{
                      backgroundColor: "rgba(255, 255, 255, 0.12)",
                      padding: "8px 16px",
                      borderRadius: "20px",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                  >
                    <ArgonTypography variant="body2" fontWeight="medium" color="white">
                      Looking for placement:{" "}
                      {tutor?.lookingForPlacement === true
                        ? "Yes"
                        : tutor?.lookingForPlacement === false
                        ? "No"
                        : "N/A"}
                    </ArgonTypography>
                  </ArgonBox>
                  {/* Registration Fee Status */}
                  <ArgonBox
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{
                      backgroundColor: tutor?.registrationFee
                        ? "rgba(76, 175, 80, 0.2)"
                        : registrationFeeWaiver
                        ? "rgba(33, 150, 243, 0.2)"
                        : "rgba(255, 152, 0, 0.2)",
                      padding: "8px 16px",
                      borderRadius: "20px",
                      border: tutor?.registrationFee
                        ? "1px solid rgba(76, 175, 80, 0.5)"
                        : registrationFeeWaiver
                        ? "1px solid rgba(33, 150, 243, 0.5)"
                        : "1px solid rgba(255, 152, 0, 0.5)",
                    }}
                  >
                    <ArgonBox
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: tutor?.registrationFee
                          ? "#4caf50"
                          : registrationFeeWaiver
                          ? "#2196f3"
                          : "#ff9800",
                      }}
                    />
                    <ArgonTypography variant="body2" fontWeight="medium" color="white">
                      Registration Fee:{" "}
                      {tutor?.registrationFee
                        ? "Paid"
                        : registrationFeeWaiver
                        ? "Waived"
                        : "Pending"}
                    </ArgonTypography>
                  </ArgonBox>

                  {!tutor?.registrationFee && (
                    <ArgonBox
                      sx={{
                        backgroundColor: "rgba(255, 255, 255, 0.12)",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                        borderRadius: "12px",
                        px: 1.5,
                        py: 0.5,
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Switch
                            checked={registrationFeeWaiver}
                            onChange={handleRegistrationFeeWaiverToggle}
                            disabled={
                              registrationFeeWaiverLoading ||
                              updateLoading ||
                              tutor?.registrationFee
                            }
                            color="info"
                          />
                        }
                        label={
                          <ArgonTypography variant="caption" color="white" fontWeight="medium">
                            Fee Waiver
                          </ArgonTypography>
                        }
                        sx={{ m: 0 }}
                      />
                    </ArgonBox>
                  )}
                </ArgonBox>
              </ArgonBox>
            </Card>
          </Grid>

          {/* Profile Information */}
          <Grid item xs={12}>
            <Card sx={{ borderRadius: 2, p: 2, boxShadow: 2 }}>
              <ArgonTypography variant="h6" fontWeight="medium" mb={2} color="primary">
                Profile Information
              </ArgonTypography>

              <Grid container spacing={2}>
                {[
                  { label: "Full Name", value: tutor?.fullName, icon: "👤" },

                  {
                    label: "Experience",
                    value:
                      tutor?.experience !== undefined && tutor?.experience !== null
                        ? `${tutor.experience} year(s)`
                        : "N/A",
                    icon: "🏆",
                  },
                  {
                    label: "Mode",
                    value: tutor?.modeOfTuition ? tutor?.modeOfTuition : "not yet",
                    icon: "💻",
                  },
                  {
                    label: "Joining Date",
                    value: tutor?.joiningDate
                      ? new Date(tutor.joiningDate).toLocaleDateString()
                      : "N/A",
                    icon: "📅",
                  },
                  {
                    label: "Availability",
                    value: availability,
                    icon: "⏰",
                  },
                  {
                    label: "Active Status",
                    value: tutor?.active === false ? "Inactive" : "Active",
                    icon: "⏰",
                  },
                  {
                    label: "Level",
                    value: tutor?.tutorLevel || "Not Set",
                    icon:
                      tutor?.tutorLevel === "Level 4"
                        ? "💎"
                        : tutor?.tutorLevel === "Level 3"
                        ? "🥇"
                        : tutor?.tutorLevel === "Level 2"
                        ? "🥈"
                        : "🥉",
                  },
                  // {
                  //   label: "English Proficiency",
                  //   value: tutor?.englishProficiency || "N/A",
                  //   icon: "📚",
                  // },
                ].map((item, index) => (
                  <Grid item xs={6} sm={4} md={3} key={index}>
                    <ArgonBox
                      sx={{
                        p: 1.5,
                        bgcolor: "#f5f7fa",
                        borderRadius: 2,
                        border: "1px solid #e0e7ff",
                      }}
                    >
                      <ArgonBox display="flex" alignItems="center" gap={1} mb={0.5}>
                        <ArgonBox sx={{ fontSize: "0.9rem" }}>{item.icon}</ArgonBox>
                        <ArgonTypography variant="caption" color="text" fontWeight="medium">
                          {item.label}
                        </ArgonTypography>
                      </ArgonBox>
                      {item.label === "Availability" ? (
                        <Dropdown
                          label=""
                          value={availability}
                          options={[
                            { label: "Available", value: "Available" },
                            { label: "Not Available", value: "Not Available" },
                            { label: "Busy", value: "Busy" },
                          ]}
                          onChange={async (e) => {
                            const newavailability = e.target.value;
                            setavailability(newavailability);
                            try {
                              await axios.put(`${baseURL}/tutor/${id}`, {
                                availability: newavailability,
                              });
                              toast.success("availability updated successfully!");
                            } catch (err) {
                              toast.error("Failed to update availability");
                              console.error("Error updating availability:", err);
                            }
                          }}
                          width="100%"
                        />
                      ) : item.label === "Active Status" ? (
                        <Dropdown
                          label=""
                          value={tutor?.active === false ? "Inactive" : "Active"}
                          options={[
                            { label: "Active", value: "Active" },
                            { label: "Inactive", value: "Inactive" },
                          ]}
                          onChange={handleTutorActiveStatusChange}
                          width="100%"
                        />
                      ) : (
                        <ArgonTypography variant="body2" fontWeight="medium" color="primary">
                          {item.value}
                        </ArgonTypography>
                      )}
                    </ArgonBox>
                  </Grid>
                ))}
                {/* Gender and Age */}
                <Grid item xs={6} sm={4} md={3}>
                  <ArgonBox
                    sx={{
                      p: 1.5,
                      bgcolor: "#f5f7fa",
                      borderRadius: 2,
                      border: "1px solid #e0e7ff",
                      height: "100%",
                    }}
                  >
                    <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
                      <ArgonBox sx={{ fontSize: "0.9rem" }}>👥</ArgonBox>
                      <ArgonTypography variant="caption" color="text" fontWeight="medium">
                        Personal Info
                      </ArgonTypography>
                    </ArgonBox>
                    <ArgonBox>
                      <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
                        <ArgonTypography variant="caption" color="text" fontWeight="medium">
                          Gender:
                        </ArgonTypography>
                        <ArgonTypography variant="body2" fontWeight="medium" color="primary">
                          {tutor?.gender || "Not Set"}
                        </ArgonTypography>
                      </ArgonBox>
                      <ArgonBox display="flex" alignItems="center" gap={1}>
                        <ArgonTypography variant="caption" color="text" fontWeight="medium">
                          Age:
                        </ArgonTypography>
                        <ArgonTypography variant="body2" fontWeight="medium" color="primary">
                          {tutor?.age || tutor?.dob
                            ? tutor?.age ||
                              new Date().getFullYear() - new Date(tutor.dob).getFullYear()
                            : "Not Set"}
                        </ArgonTypography>
                      </ArgonBox>
                    </ArgonBox>
                  </ArgonBox>
                </Grid>
                {/* availability Dropdown - removed as it's now in the grid */}{" "}
                {/* Experience Points */}
                {tutor?.experiencePoints?.length > 0 && (
                  <Grid item xs={6} sm={4} md={3}>
                    <ArgonBox
                      sx={{
                        p: 1.5,
                        bgcolor: "#f5f7fa",
                        borderRadius: 2,
                        border: "1px solid #e0e7ff",
                      }}
                    >
                      <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
                        <ArgonBox sx={{ fontSize: "0.9rem" }}>📝</ArgonBox>
                        <ArgonTypography variant="caption" color="text" fontWeight="medium">
                          Experience Points
                        </ArgonTypography>
                      </ArgonBox>
                      <ArgonBox>
                        {tutor.experiencePoints.map((point, index) => (
                          <ArgonTypography key={index} variant="body2" color="primary">
                            • {point}
                          </ArgonTypography>
                        ))}
                      </ArgonBox>
                    </ArgonBox>
                  </Grid>
                )}
                {/* Education Points */}
                {tutor?.educationPoints?.length > 0 && (
                  <Grid item xs={6} sm={4} md={3}>
                    <ArgonBox
                      sx={{
                        p: 1.5,
                        bgcolor: "#f5f7fa",
                        borderRadius: 2,
                        border: "1px solid #e0e7ff",
                      }}
                    >
                      <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
                        <ArgonBox sx={{ fontSize: "0.9rem" }}>🎓</ArgonBox>
                        <ArgonTypography variant="caption" color="text" fontWeight="medium">
                          Education Points
                        </ArgonTypography>
                      </ArgonBox>
                      <ArgonBox>
                        {tutor.educationPoints.map((point, index) => (
                          <ArgonTypography key={index} variant="body2" color="primary">
                            • {point}
                          </ArgonTypography>
                        ))}
                      </ArgonBox>
                    </ArgonBox>
                  </Grid>
                )}
                {/* Level-Based Pricing */}
                {tutor?.levelBasedPricing?.length > 0 && (
                  <Grid item xs={6} sm={4} md={3}>
                    <ArgonBox
                      sx={{
                        p: 1.5,
                        bgcolor: "#f5f7fa",
                        borderRadius: 2,
                        border: "1px solid #e0e7ff",
                        height: "100%",
                      }}
                    >
                      <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
                        <ArgonBox sx={{ fontSize: "0.9rem" }}>📊</ArgonBox>
                        <ArgonTypography variant="caption" color="text" fontWeight="medium">
                          Class-Based Pricing
                        </ArgonTypography>
                      </ArgonBox>
                      <ArgonBox>
                        {tutor.levelBasedPricing.slice(0, 3).map((pricing, index) => (
                          <ArgonBox
                            key={index}
                            display="flex"
                            flexDirection="column"
                            mb={1}
                            p={1}
                            sx={{
                              background: "#f9f9f9",
                              borderRadius: "4px",
                              border: "1px solid #e0e0e0",
                            }}
                          >
                            <ArgonTypography variant="caption" fontWeight="bold" color="dark">
                              {PRICING_LEVEL_LABELS[pricing.level] || pricing.level}
                            </ArgonTypography>
                            {pricing.subjects && pricing.subjects.length > 0 && (
                              <ArgonTypography variant="caption" color="text">
                                Subject(s): {pricing.subjects.map((s) => s.name || s).join(", ")}
                              </ArgonTypography>
                            )}
                            <ArgonTypography variant="caption" color="success" fontWeight="bold">
                              ₹{pricing.price || pricing.hourlyRate || "N/A"}/hr
                            </ArgonTypography>
                            {pricing.numberOfSessions > 0 && (
                              <ArgonTypography variant="caption" color="text">
                                Sessions: {pricing.numberOfSessions}
                              </ArgonTypography>
                            )}

                            <ArgonTypography variant="caption" color="text">
                              Margin:{" "}
                              {pricing.edushalaMargin !== undefined
                                ? `${pricing.edushalaMargin}%`
                                : "N/A"}
                            </ArgonTypography>
                          </ArgonBox>
                        ))}
                        {tutor.levelBasedPricing.length > 3 && (
                          <ArgonTypography variant="caption" color="primary" sx={{ mt: 0.5 }}>
                            +{tutor.levelBasedPricing.length - 3} more
                          </ArgonTypography>
                        )}
                      </ArgonBox>
                    </ArgonBox>
                  </Grid>
                )}
              </Grid>

              <ArgonBox
                mt={2}
                p={2}
                sx={{
                  bgcolor: "#f5f7fa",
                  borderRadius: 2,
                  border: "1px solid #e0e7ff",
                }}
              >
                <ArgonBox
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={1}
                >
                  <ArgonTypography variant="subtitle2" fontWeight="bold" color="dark">
                    Available Slots
                  </ArgonTypography>
                  <ArgonBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
                    {!availableTutorSlotsLoading && !availableTutorSlotsError && (
                      <Chip
                        size="small"
                        color="success"
                        label={`${availableTutorSlots.length} Available`}
                      />
                    )}
                    <ArgonButton
                      size="small"
                      color="primary"
                      variant="outlined"
                      onClick={handleOpenTutorSlotEditor}
                      disabled={availableTutorSlotsLoading || allTutorSlots.length === 0}
                    >
                      Edit Slots
                    </ArgonButton>
                    {/* <ArgonButton
                      size="small"
                      color="success"
                      onClick={() => setAddTutorSlotOpen(true)}
                    >
                      Add Slot
                    </ArgonButton> */}
                  </ArgonBox>
                </ArgonBox>

                {availableTutorSlotsLoading ? (
                  <ArgonBox display="flex" justifyContent="center" py={2}>
                    <CircularProgress color="success" size={26} />
                  </ArgonBox>
                ) : availableTutorSlotsError ? (
                  <ArgonTypography variant="body2" color="error" mt={1.5}>
                    {availableTutorSlotsError}
                  </ArgonTypography>
                ) : availableTutorSlots.length > 0 ? (
                  <ArgonBox display="flex" flexWrap="wrap" gap={1.25} mt={1.5}>
                    {availableTutorSlots.map((slot) => (
                      <ArgonBox
                        key={getTutorSlotId(slot) || getTutorSlotLabel(slot)}
                        sx={{
                          px: 1.5,
                          py: 1,
                          minWidth: 120,
                          textAlign: "center",
                          borderRadius: 2,
                          bgcolor: "rgba(46, 125, 50, 0.1)",
                          border: "1px solid rgba(46, 125, 50, 0.4)",
                        }}
                      >
                        <ArgonTypography variant="caption" fontWeight="bold" color="success">
                          {getTutorSlotLabel(slot) || "Slot"}
                        </ArgonTypography>
                      </ArgonBox>
                    ))}
                  </ArgonBox>
                ) : (
                  <ArgonTypography variant="body2" color="text" mt={1.5}>
                    No available slots found.
                  </ArgonTypography>
                )}
              </ArgonBox>

              {/* Action Buttons */}
              <Box display="flex" gap={1} justifyContent="center" mt={2}>
                {/* Only show Submit Meeting button if required onboarding steps are completed */}
                {tutor?.onboardingStep2Completed?.teachingPreferences &&
                  tutor?.onboardingStep2Completed?.profileInformation &&
                  tutor?.onboardingStep2Completed?.workExperience && (
                    <ArgonButton
                      onClick={handleMeetingClick}
                      variant="contained"
                      startIcon={<VideoCallIcon />}
                      color="info"
                      size="medium"
                      disabled={loadingMeeting}
                    >
                      {hasMeeting ? "Edit Meeting" : "Submit Meeting"}
                    </ArgonButton>
                  )}
                <ArgonButton
                  onClick={handleOpen}
                  variant="contained"
                  startIcon={<PersonIcon />}
                  color="primary"
                  size="medium"
                >
                  Edit Profile
                </ArgonButton>
                <ArgonButton
                  onClick={handleEvaluationOpen}
                  variant="contained"
                  startIcon={<AssessmentIcon />}
                  color="info"
                  size="medium"
                >
                  {evaluation ? "Edit Evaluation" : "Submit Evaluation"}
                </ArgonButton>
                {tutor?.onboardingStatus === "COMPLETED" && (
                  <ArgonButton
                    onClick={handleApprovalDialogOpen}
                    variant="contained"
                    color="success"
                    size="medium"
                  >
                    Approve/Reject
                  </ArgonButton>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>

        <Dialog
          open={slotEditorOpen}
          onClose={() => !slotEditorSaving && setSlotEditorOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <ArgonTypography variant="h6" fontWeight="bold">
              Edit Tutor Available Slots
            </ArgonTypography>
          </DialogTitle>
          <DialogContent>
            <ArgonTypography variant="body2" color="text" mb={2}>
              Select the free time slots this tutor can teach. Busy slots are used by active classes
              and cannot be changed here.
            </ArgonTypography>

            <ArgonBox display="flex" gap={1} flexWrap="wrap" mb={2}>
              <Chip size="small" color="success" label="Selected" />
              <Chip size="small" variant="outlined" label="Not Selected" />
              <Chip size="small" color="error" label="Busy" />
            </ArgonBox>

            <ArgonBox display="flex" flexWrap="wrap" gap={1.25}>
              {allTutorSlots.map((slot) => {
                const slotId = String(getTutorSlotId(slot));
                const isBusy = busyTutorSlotIds.map(String).includes(slotId);
                const isSelected = editedTutorSlotIds.includes(slotId);

                return (
                  <ArgonBox
                    key={slotId || getTutorSlotLabel(slot)}
                    onClick={!isBusy ? () => handleToggleTutorSlot(slotId) : undefined}
                    sx={{
                      px: 1.5,
                      py: 1,
                      minWidth: 120,
                      textAlign: "center",
                      borderRadius: 2,
                      cursor: isBusy ? "not-allowed" : "pointer",
                      opacity: isBusy ? 0.75 : 1,
                      bgcolor: isBusy
                        ? "rgba(211, 47, 47, 0.1)"
                        : isSelected
                        ? "rgba(46, 125, 50, 0.1)"
                        : "#fff",
                      border: "2px solid",
                      borderColor: isBusy
                        ? "rgba(211, 47, 47, 0.4)"
                        : isSelected
                        ? "rgba(46, 125, 50, 0.55)"
                        : "#d2d6da",
                    }}
                  >
                    <ArgonTypography
                      variant="caption"
                      fontWeight="bold"
                      color={isBusy ? "error" : isSelected ? "success" : "dark"}
                    >
                      {getTutorSlotLabel(slot) || "Slot"}
                    </ArgonTypography>
                  </ArgonBox>
                );
              })}
            </ArgonBox>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <ArgonButton
              variant="outlined"
              color="secondary"
              onClick={() => setSlotEditorOpen(false)}
              disabled={slotEditorSaving}
            >
              Cancel
            </ArgonButton>
            <ArgonButton
              variant="contained"
              color="primary"
              onClick={handleSaveTutorSlots}
              disabled={slotEditorSaving}
            >
              {slotEditorSaving ? "Saving..." : "Save Slots"}
            </ArgonButton>
          </DialogActions>
        </Dialog>

        <Dialog open={addTutorSlotOpen} onClose={handleCloseAddTutorSlot} maxWidth="sm" fullWidth>
          <DialogTitle>
            <ArgonTypography variant="h6" fontWeight="bold">
              Add New Slot
            </ArgonTypography>
          </DialogTitle>
          <form onSubmit={handleAddTutorSlot}>
            <DialogContent>
              <ArgonTypography variant="body2" color="text" mb={2}>
                Create a new time slot and make it available for this tutor.
              </ArgonTypography>
              <ArgonBox display="flex" gap={2}>
                <ArgonBox flex={1}>
                  <ArgonTypography variant="caption" fontWeight="medium" color="text">
                    Start Time
                  </ArgonTypography>
                  <ArgonBox
                    component="input"
                    type="time"
                    value={newTutorSlotStartTime}
                    onChange={(event) => setNewTutorSlotStartTime(event.target.value)}
                    disabled={addTutorSlotSaving}
                    sx={{
                      width: "100%",
                      mt: 0.5,
                      p: "10px 12px",
                      border: "1px solid #d2d6da",
                      borderRadius: "8px",
                    }}
                  />
                </ArgonBox>
                <ArgonBox flex={1}>
                  <ArgonTypography variant="caption" fontWeight="medium" color="text">
                    End Time
                  </ArgonTypography>
                  <ArgonBox
                    component="input"
                    type="time"
                    value={newTutorSlotEndTime}
                    onChange={(event) => setNewTutorSlotEndTime(event.target.value)}
                    disabled={addTutorSlotSaving}
                    sx={{
                      width: "100%",
                      mt: 0.5,
                      p: "10px 12px",
                      border: "1px solid #d2d6da",
                      borderRadius: "8px",
                    }}
                  />
                </ArgonBox>
              </ArgonBox>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <ArgonButton
                variant="outlined"
                color="secondary"
                onClick={handleCloseAddTutorSlot}
                disabled={addTutorSlotSaving}
              >
                Cancel
              </ArgonButton>
              <ArgonButton type="submit" color="success" disabled={addTutorSlotSaving}>
                {addTutorSlotSaving ? "Adding..." : "Add Slot"}
              </ArgonButton>
            </DialogActions>
          </form>
        </Dialog>

        {open && (
          <ArgonBox
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
              backdropFilter: "blur(5px)",
            }}
          >
            <ArgonBox
              sx={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "20px",
                width: "90%",
                maxWidth: 900,
                maxHeight: "95vh",
                overflowY: "auto",
                boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
                position: "relative",
              }}
            >
              {/* Header */}
              <ArgonBox
                sx={{
                  background: "rgba(255,255,255,0.1)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "20px 20px 0 0",
                  p: 3,
                  borderBottom: "1px solid rgba(255,255,255,0.2)",
                }}
              >
                <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                  <ArgonBox display="flex" alignItems="center" gap={2}>
                    <ArgonBox
                      sx={{
                        background: "rgba(255,255,255,0.2)",
                        borderRadius: "12px",
                        p: 1.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                    </ArgonBox>
                    <ArgonBox>
                      <ArgonTypography variant="h5" fontWeight="medium" color="white">
                        Edit Profile
                      </ArgonTypography>
                      <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                        Update your profile information
                      </ArgonTypography>
                    </ArgonBox>
                  </ArgonBox>
                  <ArgonButton
                    variant="text"
                    onClick={handleClose}
                    sx={{
                      color: "white",
                      minWidth: "40px",
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.1)",
                      "&:hover": { background: "rgba(255,255,255,0.2)" },
                    }}
                  >
                    ×
                  </ArgonButton>
                </ArgonBox>
              </ArgonBox>

              {/* Form Content */}
              <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
                <form onSubmit={handleUpdateTutor}>
                  <Grid container spacing={3}>
                    {/* Editable Fields */}
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Full Name
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter Full Name"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Email Address
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Date of Birth
                      </ArgonTypography>
                      <ArgonInput
                        type="date"
                        placeholder="Enter Date of Birth"
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Subject
                      </ArgonTypography>
                      <Dropdown
                        label=""
                        value={subjects}
                        options={allSubjects}
                        onChange={(e) => {
                          // For multi-select, e.target.selectedOptions
                          const selected = Array.from(e.target.selectedOptions, (opt) => opt.value);
                          setSubjects(selected);
                        }}
                        width={"100%"}
                        multiple
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Level/Badge
                      </ArgonTypography>
                      <Dropdown
                        label=""
                        value={level}
                        options={[
                          { label: "🥉 Level 1", value: "Level 1" },
                          { label: "🥈 Level 2", value: "Level 2" },
                          { label: "🥇 Level 3", value: "Level 3" },
                          { label: "💎 Level 4", value: "Level 4" },
                        ]}
                        onChange={(e) => setLevel(e.target.value)}
                        width="100%"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Experience (Years)
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter experience in years"
                        value={experience}
                        onChange={(e) => setExperience(e.target.value)}
                        fullWidth
                        size="medium"
                        type="number"
                        inputProps={{ min: 1, max: 50 }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Mobile Number
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter mobile number"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Alternate Mobile Number
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter alternate mobile number"
                        value={alternateMobile}
                        onChange={(e) => setAlternateMobile(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid>

                    {/* <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        City/Address
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter city/address"
                        value={cityAddress}
                        onChange={(e) => setCityAddress(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid> */}

                    {/* <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        State
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter state"
                        value={stateName}
                        onChange={(e) => setStateName(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid> */}

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Gender
                      </ArgonTypography>
                      <Dropdown
                        label=""
                        value={gender}
                        options={[
                          { label: "Male", value: "MALE" },
                          { label: "Female", value: "FEMALE" },
                          { label: "Other", value: "OTHER" },
                        ]}
                        onChange={(e) => setGender(e.target.value)}
                        width="100%"
                      />
                    </Grid>

                    {/* Reviews Count */}
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Reviews Count
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter reviews count"
                        value={reviewsCount}
                        onChange={(e) => setReviewsCount(e.target.value)}
                        fullWidth
                        size="medium"
                        type="number"
                        inputProps={{ min: 0 }}
                      />
                    </Grid>

                    {/* Average Rating */}
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Average Rating
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter average rating (0-5)"
                        value={averageRating}
                        onChange={(e) => setAverageRating(e.target.value)}
                        fullWidth
                        size="medium"
                        type="number"
                        inputProps={{ min: 0, max: 5, step: 0.1 }}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Referral Code
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter referral code (optional)"
                        value={referralCode}
                        onChange={(e) => setReferralCode(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Address
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter complete address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        fullWidth
                        size="medium"
                        multiline
                        minRows={2}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Description
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Write a short description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        fullWidth
                        size="medium"
                        multiline
                        minRows={2}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        About Tutor
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Write a short introduction"
                        value={about}
                        onChange={(e) => setAbout(e.target.value)}
                        fullWidth
                        size="medium"
                        multiline
                        minRows={3}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Experience Points
                      </ArgonTypography>
                      {experiencePoints.map((point, index) => (
                        <ArgonBox key={index} display="flex" alignItems="center" mb={1}>
                          <ArgonInput
                            placeholder="Enter experience point"
                            value={point}
                            onChange={(e) => {
                              const newPoints = [...experiencePoints];
                              newPoints[index] = e.target.value;
                              setExperiencePoints(newPoints);
                            }}
                            fullWidth
                            size="small"
                          />
                          <ArgonButton
                            onClick={() => {
                              const newPoints = experiencePoints.filter((_, i) => i !== index);
                              setExperiencePoints(newPoints);
                            }}
                            variant="outlined"
                            color="error"
                            size="small"
                            sx={{ ml: 1 }}
                          >
                            <HighlightOffIcon />
                          </ArgonButton>
                        </ArgonBox>
                      ))}
                      <ArgonButton
                        onClick={() => setExperiencePoints([...experiencePoints, ""])}
                        variant="outlined"
                        color="primary"
                        size="small"
                      >
                        Add Point
                      </ArgonButton>
                    </Grid>

                    <Grid item xs={12}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Education Points
                      </ArgonTypography>
                      {educationPoints.map((point, index) => (
                        <ArgonBox key={index} display="flex" alignItems="center" mb={1}>
                          <ArgonInput
                            placeholder="Enter education point"
                            value={point}
                            onChange={(e) => {
                              const newPoints = [...educationPoints];
                              newPoints[index] = e.target.value;
                              setEducationPoints(newPoints);
                            }}
                            fullWidth
                            size="small"
                          />
                          <ArgonButton
                            onClick={() => {
                              const newPoints = educationPoints.filter((_, i) => i !== index);
                              setEducationPoints(newPoints);
                            }}
                            variant="outlined"
                            color="error"
                            size="small"
                            sx={{ ml: 1 }}
                          >
                            <HighlightOffIcon />
                          </ArgonButton>
                        </ArgonBox>
                      ))}
                      <ArgonButton
                        onClick={() => setEducationPoints([...educationPoints, ""])}
                        variant="outlined"
                        color="primary"
                        size="small"
                      >
                        Add Point
                      </ArgonButton>
                    </Grid>
                    {/* Aadhaar Front Image */}
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Aadhaar Front Image
                      </ArgonTypography>
                      {aadhaarFrontPreview && (
                        <ArgonBox mb={2}>
                          <ArgonTypography variant="caption" color="text" mb={1}>
                            Current Image:
                          </ArgonTypography>
                          <ArgonBox>
                            <img
                              src={aadhaarFrontPreview}
                              alt="Aadhaar Front"
                              height="80px"
                              width="140px"
                              style={{
                                border: "1px solid #e0e7ff",
                                borderRadius: "8px",
                                objectFit: "cover",
                              }}
                            />
                          </ArgonBox>
                        </ArgonBox>
                      )}
                      <FileUploader
                        label="Upload New Aadhaar Front"
                        files={aadhaarFrontFiles}
                        setFiles={setAadhaarFrontFiles}
                        accept="image/*"
                        multiple={false}
                        Width="100%"
                        Height={120}
                      />
                    </Grid>

                    {/* Aadhaar Back Image */}
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Aadhaar Back Image
                      </ArgonTypography>
                      {aadhaarBackPreview && (
                        <ArgonBox mb={2}>
                          <ArgonTypography variant="caption" color="text" mb={1}>
                            Current Image:
                          </ArgonTypography>
                          <ArgonBox>
                            <img
                              src={aadhaarBackPreview}
                              alt="Aadhaar Back"
                              height="80px"
                              width="140px"
                              style={{
                                border: "1px solid #e0e7ff",
                                borderRadius: "8px",
                                objectFit: "cover",
                              }}
                            />
                          </ArgonBox>
                        </ArgonBox>
                      )}
                      <FileUploader
                        label="Upload New Aadhaar Back"
                        files={aadhaarBackFiles}
                        setFiles={setAadhaarBackFiles}
                        accept="image/*"
                        multiple={false}
                        Width="100%"
                        Height={120}
                      />
                    </Grid>

                    {/* Action Buttons */}
                    <ArgonBox display="flex" justifyContent="center" gap={2} mt={3} width="100%">
                      <ArgonButton
                        variant="outlined"
                        onClick={handleClose}
                        color="secondary"
                        disabled={updateLoading}
                      >
                        Cancel
                      </ArgonButton>
                      <ArgonButton
                        variant="contained"
                        type="submit"
                        color="primary"
                        disabled={updateLoading}
                        startIcon={
                          updateLoading ? <CircularProgress size={16} color="inherit" /> : null
                        }
                      >
                        {updateLoading ? "Saving..." : "Save Changes"}
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </form>
              </ArgonBox>
            </ArgonBox>
          </ArgonBox>
        )}
      </ArgonBox>

      <ArgonBox mt={4}>
        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <ArgonTypography variant="h5" fontWeight="medium" color="primary">
            Teaching Preferences
          </ArgonTypography>
          <ArgonButton
            onClick={handleTeachingPrefOpen}
            variant="contained"
            startIcon={<EditIcon />}
            color="info"
            size="small"
          >
            Edit Preferences
          </ArgonButton>
        </ArgonBox>
        <ArgonBox
          mt={3}
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {rows.length > 0 ? (
            <Table columns={columns} rows={rows} />
          ) : (
            <Card sx={{ p: 5 }}>
              <ArgonBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <PersonIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
                <ArgonTypography variant="h6" color="text">
                  No Teaching Preferences Data Available
                </ArgonTypography>
                <ArgonTypography variant="caption" color="text" textAlign="center">
                  This tutor hasn&apos;t set any teaching preferences yet.
                </ArgonTypography>
              </ArgonBox>
            </Card>
          )}
        </ArgonBox>
      </ArgonBox>

      <ArgonBox>
        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={2}>
          <ArgonTypography variant="h5" fontWeight="medium" color="primary">
            Educational Qualifications
          </ArgonTypography>
          <ArgonButton
            onClick={handleEduQualOpen}
            variant="contained"
            startIcon={<EditIcon />}
            color="info"
            size="small"
          >
            Edit Qualifications
          </ArgonButton>
        </ArgonBox>
        <ArgonBox
          mt={3}
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {rows1.length > 0 ? (
            <Table columns={columns1} rows={rows1} />
          ) : (
            <Card sx={{ p: 5 }}>
              <ArgonBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <SchoolIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
                <ArgonTypography variant="h6" color="text">
                  No Educational Qualifications Data Available
                </ArgonTypography>
                <ArgonTypography variant="caption" color="text" textAlign="center">
                  This tutor hasn&apos;t added any educational qualifications yet.
                </ArgonTypography>
              </ArgonBox>
            </Card>
          )}
        </ArgonBox>
      </ArgonBox>

      <ArgonBox>
        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={2}>
          <ArgonTypography variant="h5" fontWeight="medium" color="primary">
            Location Preferences
          </ArgonTypography>
          <ArgonButton
            onClick={handleLocationPrefOpen}
            variant="contained"
            startIcon={<EditIcon />}
            color="info"
            size="small"
          >
            Edit Locations
          </ArgonButton>
        </ArgonBox>
        <ArgonBox
          mt={3}
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {rows2.length > 0 ? (
            <Table columns={columns2} rows={rows2} />
          ) : (
            <Card sx={{ p: 5 }}>
              <ArgonBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <LocationOnIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
                <ArgonTypography variant="h6" color="text">
                  No Location Preferences Data Available
                </ArgonTypography>
                <ArgonTypography variant="caption" color="text" textAlign="center">
                  This tutor hasn&apos;t set any location preferences yet.
                </ArgonTypography>
              </ArgonBox>
            </Card>
          )}
        </ArgonBox>
      </ArgonBox>

      <ArgonBox>
        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={2}>
          <ArgonTypography variant="h5" fontWeight="medium" color="primary">
            Teaching Experience
          </ArgonTypography>
          <ArgonButton
            onClick={handleTeachingExpOpen}
            variant="contained"
            startIcon={<EditIcon />}
            color="info"
            size="small"
          >
            Edit Experience
          </ArgonButton>
        </ArgonBox>
        <ArgonBox
          mt={3}
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {rows3.length > 0 ? (
            <Table columns={columns3} rows={rows3} />
          ) : (
            <Card sx={{ p: 5 }}>
              <ArgonBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <WorkIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
                <ArgonTypography variant="h6" color="text">
                  No Teaching Experience Data Available
                </ArgonTypography>
                <ArgonTypography variant="caption" color="text" textAlign="center">
                  This tutor hasn&apos;t added any teaching experience yet.
                </ArgonTypography>
              </ArgonBox>
            </Card>
          )}
        </ArgonBox>
      </ArgonBox>

      {/* Certificates Section */}
      <ArgonBox>
        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={2}>
          <ArgonTypography variant="h5" fontWeight="medium" color="primary">
            Certificates
          </ArgonTypography>
          <ArgonButton
            onClick={handleCertificateOpen}
            variant="contained"
            startIcon={<EditIcon />}
            color="info"
            size="small"
          >
            Edit Certificates
          </ArgonButton>
        </ArgonBox>
        <ArgonBox
          mt={3}
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {rows4 && rows4.length > 0 ? (
            <Table columns={columns4} rows={rows4} />
          ) : (
            <Card sx={{ p: 5 }}>
              <ArgonBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <SchoolIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
                <ArgonTypography variant="h6" color="text">
                  No Certificates Available
                </ArgonTypography>
                <ArgonTypography variant="caption" color="text" textAlign="center">
                  This tutor hasn&apos;t added any certificates yet.
                </ArgonTypography>
              </ArgonBox>
            </Card>
          )}
        </ArgonBox>
      </ArgonBox>

      {/* Additional Documents Section */}
      <ArgonBox>
        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={2}>
          <ArgonTypography variant="h5" fontWeight="medium" color="primary">
            Additional Documents
          </ArgonTypography>
          <ArgonButton
            onClick={handleAdditionalDocsOpen}
            variant="contained"
            startIcon={<EditIcon />}
            color="info"
            size="small"
          >
            Edit Documents
          </ArgonButton>
        </ArgonBox>
        <ArgonBox
          mt={3}
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {rows6 && rows6.length > 0 ? (
            <Table columns={columns6} rows={rows6} />
          ) : (
            <Card sx={{ p: 5 }}>
              <ArgonBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <i className="ri-file-text-line" style={{ fontSize: 64, color: "#d0d0d0" }} />
                <ArgonTypography variant="h6" color="text">
                  No Additional Documents
                </ArgonTypography>
                <ArgonTypography variant="caption" color="text" textAlign="center">
                  This tutor hasn&apos;t uploaded any additional documents yet.
                </ArgonTypography>
              </ArgonBox>
            </Card>
          )}
        </ArgonBox>
      </ArgonBox>

      {/* Payment Details Section */}
      <ArgonBox>
        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={2}>
          <ArgonTypography variant="h5" fontWeight="medium" color="primary">
            Payment Details
          </ArgonTypography>
          <ArgonButton
            onClick={handlePaymentDetailsOpen}
            variant="contained"
            startIcon={<EditIcon />}
            color="info"
            size="small"
          >
            Edit Payment Details
          </ArgonButton>
        </ArgonBox>
        <ArgonBox
          mt={3}
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {rows5 && rows5.length > 0 ? (
            <Table columns={columns5} rows={rows5} />
          ) : (
            <Card sx={{ p: 5 }}>
              <ArgonBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <i className="ri-bank-card-line" style={{ fontSize: 64, color: "#d0d0d0" }} />
                <ArgonTypography variant="h6" color="text">
                  No Payment Details Available
                </ArgonTypography>
                <ArgonTypography variant="caption" color="text" textAlign="center">
                  This tutor hasn&apos;t added any payment details yet.
                </ArgonTypography>
              </ArgonBox>
            </Card>
          )}
        </ArgonBox>
      </ArgonBox>

      {/* Teaching Preferences Edit Dialog */}
      {teachingPrefOpen && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 700,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            {/* Header */}
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Teaching Preferences
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Update subjects, boards and classes you teach
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleTeachingPrefClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            {/* Form Content */}
            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={handleUpdateTeachingPreferences}>
                <Grid container spacing={3}>
                  {teachingPreferences.map((preference, index) => (
                    <Grid item xs={12} key={index}>
                      <ArgonBox
                        sx={{
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          p: 3,
                          mb: 2,
                          position: "relative",
                        }}
                      >
                        {/* Remove Button */}
                        {teachingPreferences.length > 1 && (
                          <ArgonButton
                            variant="text"
                            color="error"
                            size="small"
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              minWidth: "auto",
                              width: 30,
                              height: 30,
                              borderRadius: "50%",
                              fontSize: "18px",
                              lineHeight: 1,
                            }}
                            onClick={() => {
                              setTeachingPreferences((prev) => prev.filter((_, i) => i !== index));
                            }}
                          >
                            ×
                          </ArgonButton>
                        )}

                        <ArgonTypography variant="h6" fontWeight="medium" mb={2}>
                          Preference Set {index + 1}
                        </ArgonTypography>

                        <Grid container spacing={2}>
                          {/* Subjects */}
                          <Grid item xs={12} md={4}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Subjects
                            </ArgonTypography>
                            <Autocomplete
                              multiple
                              size="small"
                              disablePortal={false}
                              disableCloseOnSelect
                              value={preference?.subjects || []}
                              options={allSubjects.map((opt) => ({
                                _id: opt.value,
                                name: opt.label,
                              }))}
                              getOptionLabel={(option) => option?.name || ""}
                              isOptionEqualToValue={(option, value) => option?._id === value?._id}
                              onChange={(e, newValue) => {
                                const updated =
                                  teachingPreferences.length > 0 ? [...teachingPreferences] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  subjects: newValue,
                                };
                                setTeachingPreferences(updated);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Select subjects"
                                  size="small"
                                  variant="outlined"
                                />
                              )}
                              renderTags={(value, getTagProps) =>
                                value.map((option, idx) => (
                                  <Chip
                                    key={option._id || idx}
                                    label={option.name}
                                    size="small"
                                    {...getTagProps({ index: idx })}
                                  />
                                ))
                              }
                              componentsProps={{
                                popper: {
                                  style: { zIndex: 10000 },
                                },
                              }}
                            />
                          </Grid>

                          {/* Boards */}
                          <Grid item xs={12} md={4}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Boards
                            </ArgonTypography>
                            <Autocomplete
                              multiple
                              size="small"
                              disablePortal={false}
                              disableCloseOnSelect
                              value={preference?.boards || []}
                              options={allBoards.map((opt) => ({
                                _id: opt.value,
                                name: opt.label,
                              }))}
                              getOptionLabel={(option) => option?.name || ""}
                              isOptionEqualToValue={(option, value) => option?._id === value?._id}
                              onChange={(e, newValue) => {
                                const updated =
                                  teachingPreferences.length > 0 ? [...teachingPreferences] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  boards: newValue,
                                };
                                setTeachingPreferences(updated);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Select boards"
                                  size="small"
                                  variant="outlined"
                                />
                              )}
                              renderTags={(value, getTagProps) =>
                                value.map((option, idx) => (
                                  <Chip
                                    key={option._id || idx}
                                    label={option.name}
                                    size="small"
                                    {...getTagProps({ index: idx })}
                                  />
                                ))
                              }
                              componentsProps={{
                                popper: {
                                  style: { zIndex: 10000 },
                                },
                              }}
                            />
                          </Grid>

                          {/* Classes */}
                          <Grid item xs={12} md={4}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Classes
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={preference?.class?._id || ""}
                              options={allClasses}
                              onChange={(e) => {
                                const updated =
                                  teachingPreferences.length > 0 ? [...teachingPreferences] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  class: { _id: e.target.value },
                                };
                                setTeachingPreferences(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>
                        </Grid>
                      </ArgonBox>
                    </Grid>
                  ))}

                  {/* Add More Button */}
                  <Grid item xs={12}>
                    <ArgonBox display="flex" justifyContent="center" mt={2}>
                      <ArgonButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => {
                          // Append a new preference with empty arrays
                          const defaultPref = {
                            subjects: [],
                            boards: [],
                            class:
                              allClasses && allClasses.length > 0
                                ? { _id: allClasses[0].value }
                                : undefined,
                          };

                          setTeachingPreferences([...teachingPreferences, defaultPref]);
                        }}
                      >
                        + Add More Preference
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </Grid>

                {/* Action Buttons */}
                <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                  <ArgonButton variant="outlined" onClick={handleTeachingPrefClose}>
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={teachingPrefLoading}
                    startIcon={
                      teachingPrefLoading ? <CircularProgress size={16} color="inherit" /> : null
                    }
                  >
                    {teachingPrefLoading ? "Saving..." : "Save Changes"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Educational Qualifications Edit Dialog */}
      {eduQualOpen && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 800,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Educational Qualifications
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Update your educational background
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleEduQualClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={handleUpdateEducationalQualifications}>
                <Grid container spacing={3}>
                  {(eduQualifications.length > 0 ? eduQualifications : [{}]).map((qual, index) => (
                    <Grid item xs={12} key={index}>
                      <ArgonBox sx={{ border: "1px solid #e0e7ff", borderRadius: 2, p: 2, mb: 2 }}>
                        <ArgonTypography variant="h6" mb={2}>
                          Qualification {index + 1}
                        </ArgonTypography>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Qualification
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={qual?.class?._id || ""}
                              options={[
                                { label: "Select Qualification", value: "" },
                                ...allQualifications,
                              ]}
                              onChange={(e) => {
                                const updated =
                                  eduQualifications.length > 0 ? [...eduQualifications] : [{}];
                                const selectedName =
                                  allQualifications.find(
                                    (qualification) => qualification.value === e.target.value
                                  )?.label || "";
                                const boardMediumApplicable =
                                  isBoardMediumQualificationName(selectedName);
                                updated[index] = {
                                  ...updated[index],
                                  class: { _id: e.target.value },
                                };
                                if (!boardMediumApplicable) {
                                  updated[index] = {
                                    ...updated[index],
                                    board: undefined,
                                    medium: "",
                                  };
                                }
                                setEduQualifications(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>
                          {isBoardMediumApplicable(qual) && (
                            <Grid item xs={6}>
                              <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                                Board
                              </ArgonTypography>
                              <Dropdown
                                label=""
                                value={qual?.board?._id || ""}
                                options={[{ label: "Select Board", value: "" }, ...allBoards]}
                                onChange={(e) => {
                                  const updated =
                                    eduQualifications.length > 0 ? [...eduQualifications] : [{}];
                                  updated[index] = {
                                    ...updated[index],
                                    board: { _id: e.target.value },
                                  };
                                  setEduQualifications(updated);
                                }}
                                width={"100%"}
                              />
                            </Grid>
                          )}
                          {isBoardMediumApplicable(qual) && (
                            <Grid item xs={6}>
                              <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                                Medium
                              </ArgonTypography>
                              <Dropdown
                                label=""
                                value={qual?.medium || ""}
                                options={[
                                  { label: "Select Medium", value: "" },
                                  { label: "English", value: "ENGLISH" },
                                  { label: "Hindi", value: "HINDI" },
                                  { label: "Regional", value: "REGIONAL" },
                                ]}
                                onChange={(e) => {
                                  const updated =
                                    eduQualifications.length > 0 ? [...eduQualifications] : [{}];
                                  updated[index] = {
                                    ...updated[index],
                                    medium: e.target.value,
                                  };
                                  setEduQualifications(updated);
                                }}
                                width={"100%"}
                              />
                            </Grid>
                          )}
                          <Grid item xs={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Year of Completion
                            </ArgonTypography>
                            <ArgonInput
                              type="number"
                              value={qual?.completedYear || qual?.yearOfCompletion || ""}
                              onChange={(e) => {
                                const updated =
                                  eduQualifications.length > 0 ? [...eduQualifications] : [{}];
                                const yearValue = e.target.value
                                  ? parseInt(e.target.value, 10)
                                  : "";
                                updated[index] = {
                                  ...updated[index],
                                  completedYear: yearValue,
                                  yearOfCompletion: yearValue,
                                };
                                console.log(`Year updated for qualification ${index}:`, yearValue);
                                setEduQualifications(updated);
                              }}
                              fullWidth
                              placeholder="Enter year (e.g., 2020)"
                              inputProps={{
                                min: 1950,
                                max: new Date().getFullYear(),
                              }}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Institution
                            </ArgonTypography>
                            <ArgonInput
                              value={qual?.schoolUniversity || qual?.schoolUniversityCollege || ""}
                              onChange={(e) => {
                                const updated =
                                  eduQualifications.length > 0 ? [...eduQualifications] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  schoolUniversity: e.target.value,
                                  schoolUniversityCollege: e.target.value,
                                };
                                setEduQualifications(updated);
                              }}
                              fullWidth
                              placeholder="Enter institution name"
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Marksheet (Optional)
                            </ArgonTypography>
                            {eduQualMarksheetPreviews[index] && (
                              <ArgonBox mb={2}>
                                <ArgonTypography variant="caption" color="text" mb={1}>
                                  Current Marksheet:
                                </ArgonTypography>
                                <ArgonBox>
                                  <img
                                    src={eduQualMarksheetPreviews[index]}
                                    alt="Current Marksheet"
                                    height="80px"
                                    width="140px"
                                    style={{
                                      border: "1px solid #e0e7ff",
                                      borderRadius: "8px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </ArgonBox>
                              </ArgonBox>
                            )}
                            {eduQualMarksheetFiles &&
                            typeof eduQualMarksheetFiles === "object" &&
                            eduQualMarksheetFiles[index] !== undefined ? (
                              <FileUploader
                                label="Upload New Marksheet"
                                files={
                                  Array.isArray(eduQualMarksheetFiles[index])
                                    ? eduQualMarksheetFiles[index]
                                    : []
                                }
                                setFiles={(updater) => {
                                  console.log(
                                    `Setting files for qualification ${index}:`,
                                    typeof updater
                                  );
                                  setEduQualMarksheetFiles((prev) => {
                                    const currentFiles = Array.isArray(prev[index])
                                      ? prev[index]
                                      : [];
                                    const newFiles =
                                      typeof updater === "function"
                                        ? updater(currentFiles)
                                        : updater;
                                    console.log(
                                      `Updated files for qualification ${index}:`,
                                      newFiles
                                    );
                                    return {
                                      ...prev,
                                      [index]: Array.isArray(newFiles) ? newFiles : [],
                                    };
                                  });
                                }}
                                accept="image/*,application/pdf"
                                multiple={false}
                                Width="100%"
                                Height={120}
                              />
                            ) : (
                              <ArgonTypography variant="caption" color="text">
                                Loading file uploader...
                              </ArgonTypography>
                            )}
                          </Grid>
                        </Grid>
                      </ArgonBox>
                    </Grid>
                  ))}

                  {/* Add More Button */}
                  <Grid item xs={12}>
                    <ArgonBox display="flex" justifyContent="center" mt={2}>
                      <ArgonButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => {
                          const newIndex = eduQualifications.length;
                          setEduQualifications([...eduQualifications, {}]);
                          setEduQualMarksheetFiles((prev) => ({
                            ...prev,
                            [newIndex]: [],
                          }));
                          console.log(`Added new qualification at index ${newIndex}`);
                        }}
                      >
                        + Add More Qualification
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </Grid>

                <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                  <ArgonButton variant="outlined" onClick={handleEduQualClose}>
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={eduQualLoading}
                    startIcon={
                      eduQualLoading ? <CircularProgress size={16} color="inherit" /> : null
                    }
                  >
                    {eduQualLoading ? "Saving..." : "Save Changes"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Location Preferences Edit Dialog */}
      {locationPrefOpen && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 700,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Location Preferences
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Update your preferred teaching locations
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleLocationPrefClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={handleUpdateLocationPreferences}>
                <Grid container spacing={3}>
                  {(locationPreferences.length > 0 ? locationPreferences : [{}]).map(
                    (location, index) => (
                      <Grid item xs={12} key={index}>
                        <ArgonBox
                          sx={{ border: "1px solid #e0e7ff", borderRadius: 2, p: 2, mb: 2 }}
                        >
                          <ArgonBox
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mb={2}
                          >
                            <ArgonTypography variant="h6">Location {index + 1}</ArgonTypography>
                            <ArgonButton
                              variant="text"
                              color="primary"
                              size="small"
                              onClick={() => {
                                setSelectedLocationIndex(index);
                                // Always set map center when clicking - either to existing location or keep current
                                if (location?.lat && location?.lng) {
                                  setMapCenter({
                                    lat: parseFloat(location.lat),
                                    lng: parseFloat(location.lng),
                                  });
                                }
                              }}
                            >
                              📍 Select on Map
                            </ArgonButton>
                          </ArgonBox>

                          {/* Google Map for location selection */}
                          {selectedLocationIndex === index && (
                            <ArgonBox
                              mb={2}
                              sx={{
                                height: "300px",
                                borderRadius: 2,
                                overflow: "hidden",
                                position: "relative",
                              }}
                            >
                              {loadError && (
                                <ArgonBox
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  height="100%"
                                  bgcolor="#f5f5f5"
                                  p={3}
                                >
                                  <ArgonTypography variant="body2" color="error" textAlign="center">
                                    Map cannot be loaded. Please check your internet connection or
                                    try manual entry.
                                  </ArgonTypography>
                                </ArgonBox>
                              )}
                              {!isLoaded && !loadError && (
                                <ArgonBox
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  height="100%"
                                  bgcolor="#f5f5f5"
                                >
                                  <CircularProgress size={40} />
                                </ArgonBox>
                              )}
                              {isLoaded && !loadError && (
                                <GoogleMap
                                  mapContainerStyle={{ width: "100%", height: "100%" }}
                                  center={mapCenter}
                                  zoom={13}
                                  onClick={(e) => {
                                    if (e.latLng) {
                                      const lat = e.latLng.lat();
                                      const lng = e.latLng.lng();
                                      const updated =
                                        locationPreferences.length > 0
                                          ? [...locationPreferences]
                                          : [{}];
                                      updated[index] = {
                                        ...updated[index],
                                        lat: lat,
                                        lng: lng,
                                      };
                                      setLocationPreferences(updated);
                                      setMapCenter({ lat, lng });
                                    }
                                  }}
                                  options={{
                                    streetViewControl: false,
                                    mapTypeControl: false,
                                    fullscreenControl: false,
                                  }}
                                >
                                  {location?.lat && location?.lng && (
                                    <MarkerF position={{ lat: location.lat, lng: location.lng }} />
                                  )}
                                </GoogleMap>
                              )}
                            </ArgonBox>
                          )}

                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                              <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                                Latitude
                              </ArgonTypography>
                              <ArgonInput
                                type="number"
                                value={location?.lat || location?.latitude || ""}
                                onChange={(e) => {
                                  const updated =
                                    locationPreferences.length > 0
                                      ? [...locationPreferences]
                                      : [{}];
                                  updated[index] = {
                                    ...updated[index],
                                    lat: e.target.value ? parseFloat(e.target.value) : undefined,
                                  };
                                  setLocationPreferences(updated);
                                  if (e.target.value && updated[index].lng) {
                                    setMapCenter({
                                      lat: parseFloat(e.target.value),
                                      lng: updated[index].lng,
                                    });
                                  }
                                }}
                                fullWidth
                                placeholder="Click on map or enter latitude"
                                inputProps={{ step: "any", min: -90, max: 90 }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                                Longitude
                              </ArgonTypography>
                              <ArgonInput
                                type="number"
                                value={location?.lng || location?.longitude || ""}
                                onChange={(e) => {
                                  const updated =
                                    locationPreferences.length > 0
                                      ? [...locationPreferences]
                                      : [{}];
                                  updated[index] = {
                                    ...updated[index],
                                    lng: e.target.value ? parseFloat(e.target.value) : undefined,
                                  };
                                  setLocationPreferences(updated);
                                  if (e.target.value && updated[index].lat) {
                                    setMapCenter({
                                      lat: updated[index].lat,
                                      lng: parseFloat(e.target.value),
                                    });
                                  }
                                }}
                                fullWidth
                                placeholder="Click on map or enter longitude"
                                inputProps={{ step: "any", min: -180, max: 180 }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                                Radius (km)
                              </ArgonTypography>
                              <ArgonInput
                                type="number"
                                value={location?.radius || ""}
                                onChange={(e) => {
                                  const updated =
                                    locationPreferences.length > 0
                                      ? [...locationPreferences]
                                      : [{}];
                                  updated[index] = {
                                    ...updated[index],
                                    radius: e.target.value ? parseFloat(e.target.value) : undefined,
                                  };
                                  setLocationPreferences(updated);
                                }}
                                fullWidth
                                placeholder="Enter radius in km"
                                inputProps={{ step: "any", min: 0 }}
                              />
                            </Grid>
                          </Grid>
                        </ArgonBox>
                      </Grid>
                    )
                  )}

                  {/* Add More Button */}
                  <Grid item xs={12}>
                    <ArgonBox display="flex" justifyContent="center" mt={2}>
                      <ArgonButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => {
                          setLocationPreferences([...locationPreferences, {}]);
                        }}
                      >
                        + Add More Location
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </Grid>

                <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                  <ArgonButton variant="outlined" onClick={handleLocationPrefClose}>
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={locationPrefLoading}
                    startIcon={
                      locationPrefLoading ? <CircularProgress size={16} color="inherit" /> : null
                    }
                  >
                    {locationPrefLoading ? "Saving..." : "Save Changes"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Teaching Experience Edit Dialog */}
      {teachingExpOpen && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 800,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Teaching Experience
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Update your teaching experience details
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleTeachingExpClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={handleUpdateTeachingExperience}>
                <Grid container spacing={3}>
                  {(teachingExperience.length > 0 ? teachingExperience : [{}]).map((exp, index) => (
                    <Grid item xs={12} key={index}>
                      <ArgonBox sx={{ border: "1px solid #e0e7ff", borderRadius: 2, p: 2, mb: 2 }}>
                        <ArgonTypography variant="h6" mb={2}>
                          Experience {index + 1}
                        </ArgonTypography>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Organization *
                            </ArgonTypography>
                            <ArgonInput
                              value={exp?.organization || exp?.institutionOrganization || ""}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  organization: e.target.value,
                                  institutionOrganization: e.target.value,
                                };
                                setTeachingExperience(updated);
                              }}
                              fullWidth
                              placeholder="Enter organization name"
                              required
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Position *
                            </ArgonTypography>
                            <ArgonInput
                              value={exp?.position || exp?.positionRole || ""}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  position: e.target.value,
                                  positionRole: e.target.value,
                                };
                                setTeachingExperience(updated);
                              }}
                              fullWidth
                              placeholder="Enter position/role"
                              required
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Start Date *
                            </ArgonTypography>
                            <ArgonInput
                              type="date"
                              value={
                                exp?.startDate
                                  ? new Date(exp.startDate).toISOString().split("T")[0]
                                  : ""
                              }
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  startDate: e.target.value,
                                };
                                setTeachingExperience(updated);
                              }}
                              fullWidth
                              required
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              End Date
                            </ArgonTypography>
                            <ArgonInput
                              type="date"
                              value={
                                exp?.endDate
                                  ? new Date(exp.endDate).toISOString().split("T")[0]
                                  : ""
                              }
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  endDate: e.target.value,
                                };
                                setTeachingExperience(updated);
                              }}
                              fullWidth
                              disabled={exp?.isCurrentlyWorking}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Experience Type
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={exp?.experienceType || "TEACHING"}
                              options={[
                                { label: "Teaching", value: "TEACHING" },
                                { label: "Non-Teaching", value: "NON_TEACHING" },
                                { label: "Corporate", value: "CORPORATE" },
                                { label: "Freelance", value: "FREELANCE" },
                                { label: "Other", value: "OTHER" },
                              ]}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  experienceType: e.target.value,
                                };
                                setTeachingExperience(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ArgonBox display="flex" alignItems="center" mt={4}>
                              <input
                                type="checkbox"
                                checked={exp?.isCurrentlyWorking || false}
                                onChange={(e) => {
                                  const updated =
                                    teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                  updated[index] = {
                                    ...updated[index],
                                    isCurrentlyWorking: e.target.checked,
                                    endDate: e.target.checked ? "" : updated[index].endDate,
                                  };
                                  setTeachingExperience(updated);
                                }}
                                style={{ marginRight: "8px" }}
                              />
                              <ArgonTypography variant="body2">Currently Working</ArgonTypography>
                            </ArgonBox>
                          </Grid>
                          <Grid item xs={12}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Description
                            </ArgonTypography>
                            <ArgonInput
                              multiline
                              rows={3}
                              value={exp?.description || exp?.subjectTaught || ""}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  description: e.target.value,
                                  subjectTaught: e.target.value,
                                };
                                setTeachingExperience(updated);
                              }}
                              fullWidth
                              placeholder="Enter job description or subjects taught"
                            />
                          </Grid>

                          {/* Classes Field */}
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Class
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={
                                Array.isArray(exp?.classes) && exp.classes.length > 0
                                  ? exp.classes[0]._id || exp.classes[0]
                                  : exp?.classes?._id || exp?.classes || ""
                              }
                              options={allClasses}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  classes: e.target.value ? [e.target.value] : [],
                                };
                                setTeachingExperience(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>

                          {/* Board Field */}
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Board
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={
                                Array.isArray(exp?.boards) && exp.boards.length > 0
                                  ? exp.boards[0]._id || exp.boards[0]
                                  : exp?.boards?._id || exp?.boards || ""
                              }
                              options={allBoards}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  boards: e.target.value ? [e.target.value] : [],
                                };
                                setTeachingExperience(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>

                          {/* Subject Field */}
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Subject
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={
                                Array.isArray(exp?.subjects) && exp.subjects.length > 0
                                  ? exp.subjects[0]._id || exp.subjects[0]
                                  : exp?.subjects?._id || exp?.subjects || ""
                              }
                              options={allSubjects}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  subjects: e.target.value ? [e.target.value] : [],
                                };
                                setTeachingExperience(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>
                        </Grid>
                      </ArgonBox>
                    </Grid>
                  ))}

                  {/* Add More Button */}
                  <Grid item xs={12}>
                    <ArgonBox display="flex" justifyContent="center" mt={2}>
                      <ArgonButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => {
                          setTeachingExperience([...teachingExperience, {}]);
                        }}
                      >
                        + Add More Experience
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </Grid>

                <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                  <ArgonButton variant="outlined" onClick={handleTeachingExpClose}>
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={teachingExpLoading}
                    startIcon={
                      teachingExpLoading ? <CircularProgress size={16} color="inherit" /> : null
                    }
                  >
                    {teachingExpLoading ? "Saving..." : "Save Changes"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Certificates Edit Dialog */}
      {certificateOpen && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 800,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <SchoolIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Certificates
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Add or update your certificates
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleCertificateClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={handleUpdateCertificates}>
                <Grid container spacing={3}>
                  {(certificates.length > 0
                    ? certificates
                    : [{ certificateName: "", certificateImage: "" }]
                  ).map((cert, index) => (
                    <Grid item xs={12} key={index}>
                      <ArgonBox sx={{ border: "1px solid #e0e7ff", borderRadius: 2, p: 2, mb: 2 }}>
                        <ArgonBox
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          mb={2}
                        >
                          <ArgonTypography variant="h6">Certificate {index + 1}</ArgonTypography>
                          {certificates.length > 1 && (
                            <ArgonButton
                              variant="text"
                              color="error"
                              size="small"
                              onClick={() => handleRemoveCertificate(index)}
                            >
                              Remove
                            </ArgonButton>
                          )}
                        </ArgonBox>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Certificate Name *
                            </ArgonTypography>
                            <ArgonInput
                              value={cert?.certificateName || ""}
                              onChange={(e) =>
                                handleCertificateChange(index, "certificateName", e.target.value)
                              }
                              fullWidth
                              placeholder="Enter certificate name"
                              required
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Certificate Image *
                            </ArgonTypography>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleCertificateImageUpload(index, e.target.files[0])
                              }
                              style={{ display: "none" }}
                              id={`certificate-upload-${index}`}
                            />
                            <label htmlFor={`certificate-upload-${index}`}>
                              <ArgonButton
                                component="span"
                                variant="outlined"
                                color="info"
                                fullWidth
                              >
                                {cert?.certificateImage ? "Change Image" : "Upload Image"}
                              </ArgonButton>
                            </label>
                          </Grid>
                          {cert?.certificateImage && (
                            <Grid item xs={12}>
                              <ArgonBox mt={1} textAlign="center">
                                <img
                                  src={cert.certificateImage}
                                  alt="Certificate Preview"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "200px",
                                    borderRadius: "10px",
                                    border: "2px solid #e0e0e0",
                                  }}
                                />
                              </ArgonBox>
                            </Grid>
                          )}
                        </Grid>
                      </ArgonBox>
                    </Grid>
                  ))}

                  {/* Add More Button */}
                  <Grid item xs={12}>
                    <ArgonBox display="flex" justifyContent="center" mt={2}>
                      <ArgonButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={handleAddCertificate}
                      >
                        + Add More Certificate
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </Grid>

                <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                  <ArgonButton variant="outlined" onClick={handleCertificateClose}>
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    variant="contained"
                    type="submit"
                    color="success"
                    disabled={certificateLoading}
                    startIcon={
                      certificateLoading ? <CircularProgress size={16} color="inherit" /> : null
                    }
                  >
                    {certificateLoading ? "Saving..." : "Save Certificates"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Additional Documents Edit Dialog */}
      {additionalDocsOpen && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 800,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i className="ri-file-text-line" style={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Additional Documents
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Add or update additional documents
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleAdditionalDocsClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={handleUpdateAdditionalDocs}>
                <Grid container spacing={3}>
                  {(additionalDocuments.length > 0
                    ? additionalDocuments
                    : [{ documentTitle: "", documentUrl: "" }]
                  ).map((doc, index) => (
                    <Grid item xs={12} key={index}>
                      <ArgonBox sx={{ border: "1px solid #e0e7ff", borderRadius: 2, p: 2, mb: 2 }}>
                        <ArgonBox
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          mb={2}
                        >
                          <ArgonTypography variant="h6">Document {index + 1}</ArgonTypography>
                          {additionalDocuments.length > 1 && (
                            <ArgonButton
                              variant="text"
                              color="error"
                              size="small"
                              onClick={() => handleRemoveAdditionalDoc(index)}
                            >
                              Remove
                            </ArgonButton>
                          )}
                        </ArgonBox>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Document Title *
                            </ArgonTypography>
                            <ArgonInput
                              value={doc?.documentTitle || ""}
                              onChange={(e) =>
                                handleAdditionalDocChange(index, "documentTitle", e.target.value)
                              }
                              fullWidth
                              placeholder="Enter document title"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Document File * (All formats supported)
                            </ArgonTypography>
                            <input
                              type="file"
                              onChange={(e) => handleAdditionalDocUpload(index, e.target.files[0])}
                              style={{ display: "none" }}
                              id={`additional-doc-upload-${index}`}
                            />
                            <label htmlFor={`additional-doc-upload-${index}`}>
                              <ArgonButton
                                component="span"
                                variant="outlined"
                                color="info"
                                fullWidth
                              >
                                {doc?.documentFile || doc?.documentUrl
                                  ? "Change File"
                                  : "Upload File"}
                              </ArgonButton>
                            </label>
                          </Grid>
                          {(doc?.fileName || doc?.documentUrl) && (
                            <Grid item xs={12}>
                              <ArgonBox
                                mt={1}
                                p={2}
                                sx={{
                                  background: "#f0fdf4",
                                  borderRadius: "8px",
                                  border: "1px solid #bbf7d0",
                                }}
                              >
                                <ArgonBox display="flex" alignItems="center" gap={1}>
                                  <i
                                    className="ri-file-text-line"
                                    style={{ color: "#22c55e", fontSize: "20px" }}
                                  />
                                  <ArgonBox flex={1}>
                                    <ArgonTypography
                                      variant="caption"
                                      fontWeight="bold"
                                      color="success"
                                    >
                                      {doc?.fileName ? (
                                        <>
                                          {doc.fileName}
                                          {doc?.fileSize && (
                                            <span style={{ color: "#64748b" }}>
                                              {" "}
                                              ({doc.fileSize} KB)
                                            </span>
                                          )}
                                        </>
                                      ) : (
                                        "Existing document uploaded"
                                      )}
                                    </ArgonTypography>
                                    {doc?.documentUrl && !doc?.fileName && (
                                      <ArgonBox mt={0.5}>
                                        <ArgonButton
                                          component="a"
                                          href={doc.documentUrl}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          variant="text"
                                          color="info"
                                          size="small"
                                          sx={{ p: 0, minWidth: "auto" }}
                                        >
                                          View File
                                        </ArgonButton>
                                      </ArgonBox>
                                    )}
                                  </ArgonBox>
                                </ArgonBox>
                              </ArgonBox>
                            </Grid>
                          )}
                        </Grid>
                      </ArgonBox>
                    </Grid>
                  ))}

                  {/* Add More Button */}
                  <Grid item xs={12}>
                    <ArgonBox display="flex" justifyContent="center" mt={2}>
                      <ArgonButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={handleAddAdditionalDoc}
                      >
                        + Add More Document
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </Grid>

                <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                  <ArgonButton variant="outlined" onClick={handleAdditionalDocsClose}>
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    variant="contained"
                    type="submit"
                    color="success"
                    disabled={additionalDocsLoading}
                    startIcon={
                      additionalDocsLoading ? <CircularProgress size={16} color="inherit" /> : null
                    }
                  >
                    {additionalDocsLoading ? "Saving..." : "Save Documents"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Payment Details Edit Dialog */}
      {paymentDetailsOpen && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 700,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i className="ri-bank-card-line" style={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Payment Details
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Add or update payment information
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handlePaymentDetailsClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={handleUpdatePaymentDetails}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Payment Mode *
                    </ArgonTypography>
                    <Dropdown
                      value={paymentMode}
                      options={["BANK", "UPI"]}
                      onChange={(e) => setPaymentMode(e.target.value)}
                    />
                  </Grid>

                  {paymentMode === "BANK" && (
                    <>
                      <Grid item xs={12}>
                        <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                          Bank Name *
                        </ArgonTypography>
                        <ArgonInput
                          value={bankName}
                          onChange={(e) => setBankName(e.target.value)}
                          fullWidth
                          placeholder="Enter bank name (e.g., HDFC Bank)"
                          required
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                          Account Number *
                        </ArgonTypography>
                        <ArgonInput
                          value={accountNumber}
                          onChange={(e) => setAccountNumber(e.target.value)}
                          fullWidth
                          placeholder="Enter account number"
                          required
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                          IFSC Code *
                        </ArgonTypography>
                        <ArgonInput
                          value={ifscCode}
                          onChange={(e) => {
                            const value = e.target.value.toUpperCase();
                            // Allow only alphanumeric characters, max 11 characters
                            if (/^[A-Z0-9]*$/.test(value) && value.length <= 11) {
                              setIfscCode(value);
                            }
                          }}
                          fullWidth
                          placeholder="Enter IFSC code (e.g., HDFC0001234)"
                          required
                          inputProps={{
                            maxLength: 11,
                            style: { textTransform: "uppercase" },
                          }}
                        />
                        <ArgonTypography variant="caption" color="text" mt={0.5}>
                          IFSC code must be 11 characters (e.g., HDFC0001234)
                        </ArgonTypography>
                      </Grid>

                      <Grid item xs={12}>
                        <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                          Account Holder Name *
                        </ArgonTypography>
                        <ArgonInput
                          value={accountHolderName}
                          onChange={(e) => setAccountHolderName(e.target.value)}
                          fullWidth
                          placeholder="Enter account holder name"
                          required
                        />
                      </Grid>
                    </>
                  )}

                  {paymentMode === "UPI" && (
                    <Grid item xs={12}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        UPI ID *
                      </ArgonTypography>
                      <ArgonInput
                        value={upiId}
                        onChange={(e) => setUpiId(e.target.value)}
                        fullWidth
                        placeholder="Enter UPI ID (e.g., username@paytm)"
                        required
                      />
                    </Grid>
                  )}
                </Grid>

                <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                  <ArgonButton variant="outlined" onClick={handlePaymentDetailsClose}>
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    variant="contained"
                    type="submit"
                    color="success"
                    disabled={paymentDetailsLoading}
                    startIcon={
                      paymentDetailsLoading ? <CircularProgress size={16} color="inherit" /> : null
                    }
                  >
                    {paymentDetailsLoading ? "Saving..." : "Save Payment Details"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Evaluation Form Dialog */}
      {openEvaluation && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 900,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            {/* Header */}
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <AssessmentIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      {evaluation ? "Edit Tutor Evaluation" : "Add Tutor Evaluation"}
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Evaluate tutor&apos;s teaching capabilities
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleEvaluationClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            {/* Form Content */}
            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <Grid container spacing={3}>
                {/* Introduction Rating */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Introduction Rating (0-5)
                  </ArgonTypography>
                  <ArgonInput
                    type="number"
                    placeholder="Enter rating (0-5)"
                    value={evaluationForm.introduction}
                    onChange={(e) => {
                      const val = e.target.value === "" ? 0 : parseInt(e.target.value);
                      setEvaluationForm({ ...evaluationForm, introduction: val });
                    }}
                    fullWidth
                    size="medium"
                    inputProps={{ min: 0, max: 5 }}
                  />
                </Grid>

                {/* English Proficiency */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    English Proficiency
                  </ArgonTypography>
                  <Dropdown
                    label=""
                    value={evaluationForm.english}
                    options={[
                      { label: "Basic", value: "BASIC" },
                      { label: "Intermediate", value: "INTERMEDIATE" },
                      { label: "Fluent", value: "FLUENT" },
                      { label: "Native", value: "NATIVE" },
                    ]}
                    onChange={(e) =>
                      setEvaluationForm({ ...evaluationForm, english: e.target.value })
                    }
                    width="100%"
                  />
                </Grid>

                {/* English Rating */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    English Rating (1-10)
                  </ArgonTypography>
                  <ArgonInput
                    type="number"
                    placeholder="Enter rating (1-10)"
                    value={evaluationForm.englishRating}
                    onChange={(e) => {
                      const val = e.target.value === "" ? 1 : parseInt(e.target.value);
                      setEvaluationForm({ ...evaluationForm, englishRating: val });
                    }}
                    fullWidth
                    size="medium"
                    inputProps={{ min: 1, max: 10 }}
                  />
                </Grid>

                {/* Bilingual Rating */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Bilingual (1-10)
                  </ArgonTypography>
                  <ArgonInput
                    type="number"
                    placeholder="Enter rating (1-10)"
                    value={evaluationForm.hindiRating}
                    onChange={(e) => {
                      const val = e.target.value === "" ? 1 : parseInt(e.target.value);
                      setEvaluationForm({ ...evaluationForm, hindiRating: val });
                    }}
                    fullWidth
                    size="medium"
                    inputProps={{ min: 1, max: 10 }}
                  />
                </Grid>

                {/* Tone/Pitch */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Tone/Pitch
                  </ArgonTypography>
                  <Dropdown
                    label=""
                    value={evaluationForm.tonePitch}
                    options={[
                      { label: "Low", value: "LOW" },
                      { label: "Medium", value: "MEDIUM" },
                      { label: "High", value: "HIGH" },
                    ]}
                    onChange={(e) =>
                      setEvaluationForm({ ...evaluationForm, tonePitch: e.target.value })
                    }
                    width="100%"
                  />
                </Grid>

                {/* Cross Questions Rating */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Cross Questions Rating (1-10)
                  </ArgonTypography>
                  <TextField
                    type="number"
                    fullWidth
                    value={evaluationForm.crossQuestions}
                    onChange={(e) => {
                      const val = e.target.value === "" ? 1 : parseInt(e.target.value);
                      setEvaluationForm({ ...evaluationForm, crossQuestions: val });
                    }}
                    inputProps={{ min: 1, max: 10 }}
                    size="small"
                  />
                </Grid>

                {/* Confidence Level */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Confidence Level (1-10)
                  </ArgonTypography>
                  <TextField
                    type="number"
                    fullWidth
                    value={evaluationForm.confidenceLevel}
                    onChange={(e) => {
                      const val = e.target.value === "" ? 1 : parseInt(e.target.value);
                      setEvaluationForm({ ...evaluationForm, confidenceLevel: val });
                    }}
                    inputProps={{ min: 1, max: 10 }}
                    size="small"
                  />
                </Grid>

                {/* Subject Ratings */}
                <Grid item xs={12}>
                  <ArgonTypography variant="h6" fontWeight="medium" mb={2}>
                    Subject-wise Concept Ratings
                  </ArgonTypography>

                  {evaluationForm.subjectRatings.map((subjectRating, index) => {
                    // Filter to show all subjects
                    const tutorSubjectOptions = allSubjects.filter(
                      (subject) =>
                        !evaluationForm.subjectRatings.some(
                          (sr, i) => i !== index && sr.subjectId === subject.value
                        )
                    );

                    return (
                      <Grid container spacing={2} key={index} mb={2} alignItems="flex-end">
                        <Grid item xs={12} md={5}>
                          <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                            Subject
                          </ArgonTypography>
                          <Dropdown
                            label=""
                            value={subjectRating.subjectId || ""}
                            options={tutorSubjectOptions}
                            onChange={(e) => {
                              const updated = [...evaluationForm.subjectRatings];
                              updated[index] = { ...updated[index], subjectId: e.target.value };
                              setEvaluationForm({ ...evaluationForm, subjectRatings: updated });
                            }}
                            width="100%"
                          />
                        </Grid>
                        <Grid item xs={12} md={5}>
                          <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                            Rating (1-10)
                          </ArgonTypography>
                          <TextField
                            type="number"
                            fullWidth
                            value={subjectRating.rating || 1}
                            onChange={(e) => {
                              const val = e.target.value === "" ? 1 : parseInt(e.target.value);
                              const updated = [...evaluationForm.subjectRatings];
                              updated[index] = { ...updated[index], rating: val };
                              setEvaluationForm({ ...evaluationForm, subjectRatings: updated });
                            }}
                            inputProps={{ min: 1, max: 10 }}
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <ArgonButton
                            variant="outlined"
                            color="error"
                            size="small"
                            fullWidth
                            onClick={() => {
                              const updated = evaluationForm.subjectRatings.filter(
                                (_, i) => i !== index
                              );
                              setEvaluationForm({ ...evaluationForm, subjectRatings: updated });
                            }}
                          >
                            Remove
                          </ArgonButton>
                        </Grid>
                      </Grid>
                    );
                  })}

                  <ArgonButton
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => {
                      const availableSubjects = allSubjects.filter(
                        (subject) =>
                          !evaluationForm.subjectRatings.some(
                            (sr) => sr.subjectId === subject.value
                          )
                      );

                      if (availableSubjects.length === 0) {
                        toast.info("All subjects have been rated or no subjects available");
                        return;
                      }

                      setEvaluationForm({
                        ...evaluationForm,
                        subjectRatings: [
                          ...evaluationForm.subjectRatings,
                          { subjectId: "", rating: 1 },
                        ],
                      });
                    }}
                  >
                    + Add Subject Rating
                  </ArgonButton>
                </Grid>

                {/* Teaching Methods */}
                <Grid item xs={12}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Teaching Methods
                  </ArgonTypography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6} ml={1.5}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={evaluationForm.startingFromBasics}
                            onChange={(e) =>
                              setEvaluationForm({
                                ...evaluationForm,
                                startingFromBasics: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Starting from Basics"
                      />
                    </Grid>
                    <Grid item xs={12} md={5} ml={1.5}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={evaluationForm.smoothExplanations}
                            onChange={(e) =>
                              setEvaluationForm({
                                ...evaluationForm,
                                smoothExplanations: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Smooth Explanations"
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Speech Impediment */}
                <Grid item xs={12}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6} ml={1.5}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={evaluationForm.lisp}
                            onChange={(e) =>
                              setEvaluationForm({ ...evaluationForm, lisp: e.target.checked })
                            }
                          />
                        }
                        label="Speech Impediment (Lisp)"
                      />
                    </Grid>

                    {/* Lisp Category */}
                    {evaluationForm.lisp && (
                      <Grid item xs={12} md={6}>
                        <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                          Speech Impediment Category
                        </ArgonTypography>
                        <RadioGroup
                          row
                          sx={{ ml: 1.5 }}
                          value={evaluationForm.lispCategory || ""}
                          onChange={(e) =>
                            setEvaluationForm({ ...evaluationForm, lispCategory: e.target.value })
                          }
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                      </Grid>
                    )}
                  </Grid>
                </Grid>

                {/* Personality Assessment */}
                <Grid item xs={12}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Personality Assessment
                  </ArgonTypography>
                  <ArgonInput
                    fullWidth
                    multiline
                    rows={2}
                    placeholder="Enter personality assessment"
                    value={evaluationForm.personalityWise}
                    onChange={(e) =>
                      setEvaluationForm({ ...evaluationForm, personalityWise: e.target.value })
                    }
                    size="small"
                  />
                </Grid>

                {/* Remarks */}
                <Grid item xs={12}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Remarks
                  </ArgonTypography>
                  <ArgonInput
                    fullWidth
                    multiline
                    rows={3}
                    placeholder="Enter remarks"
                    value={evaluationForm.remarks}
                    onChange={(e) =>
                      setEvaluationForm({ ...evaluationForm, remarks: e.target.value })
                    }
                    size="small"
                  />
                </Grid>
              </Grid>

              <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                <ArgonButton variant="outlined" onClick={handleEvaluationClose}>
                  Cancel
                </ArgonButton>
                <ArgonButton
                  variant="contained"
                  color="info"
                  onClick={handleEvaluationSubmit}
                  disabled={savingEvaluation}
                  startIcon={
                    savingEvaluation ? <CircularProgress size={16} color="inherit" /> : null
                  }
                >
                  {savingEvaluation ? "Saving..." : "Submit"}
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Approval/Rejection Dialog */}
      {openApprovalDialog && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "white",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 1000,
              maxHeight: "90vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            {/* Header */}
            <ArgonBox
              sx={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "20px 20px 0 0",
                p: 3,
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonTypography variant="h5" fontWeight="medium" color="white">
                  Approve or Reject Tutor
                </ArgonTypography>
                <ArgonButton
                  variant="text"
                  onClick={handleApprovalDialogClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            {/* Form Content */}
            <ArgonBox sx={{ p: 4 }}>
              <Grid container spacing={3}>
                {/* Approval Status Selection */}
                <Grid item xs={12}>
                  <ArgonTypography variant="body2" fontWeight="bold" mb={2}>
                    Select Action
                  </ArgonTypography>
                  <Box display="flex" gap={2}>
                    <ArgonButton
                      variant={
                        approvalForm.approvalStatus === "APPROVED" ? "contained" : "outlined"
                      }
                      color="success"
                      onClick={() =>
                        setApprovalForm({ ...approvalForm, approvalStatus: "APPROVED" })
                      }
                      fullWidth
                    >
                      Approve
                    </ArgonButton>
                    <ArgonButton
                      variant={
                        approvalForm.approvalStatus === "REJECTED" ? "contained" : "outlined"
                      }
                      color="error"
                      onClick={() =>
                        setApprovalForm({ ...approvalForm, approvalStatus: "REJECTED" })
                      }
                      fullWidth
                    >
                      Reject
                    </ArgonButton>
                  </Box>
                </Grid>

                {/* Approved Fields */}
                {approvalForm.approvalStatus === "APPROVED" && (
                  <>
                    <Grid item xs={12}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Level/Badge
                      </ArgonTypography>
                      <Dropdown
                        label=""
                        value={approvalForm.badgeLevel}
                        options={[
                          { label: "🥉 Level 1", value: "Level 1" },
                          { label: "🥈 Level 2", value: "Level 2" },
                          { label: "🥇 Level 3", value: "Level 3" },
                          { label: "💎 Level 4", value: "Level 4" },
                        ]}
                        onChange={(e) =>
                          setApprovalForm({ ...approvalForm, badgeLevel: e.target.value })
                        }
                        width="100%"
                      />
                    </Grid>

                    {/* Level-Based Pricing Section */}
                    <Grid item xs={12}>
                      <ArgonBox
                        sx={{
                          p: 2,
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          background: "#f9f9f9",
                        }}
                      >
                        <ArgonBox
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          mb={2}
                        >
                          <ArgonTypography variant="body2" fontWeight="bold">
                            📊 Class-Based Pricing
                          </ArgonTypography>
                          <ArgonButton
                            size="small"
                            color="success"
                            onClick={() => {
                              // Map class names to education levels
                              const getEducationLevel = (className) => {
                                if (!className) return null;
                                const name = className.toLowerCase();

                                if (
                                  name.includes("kg") ||
                                  name.includes("kindergarten") ||
                                  name.includes("nursery") ||
                                  name.includes("lkg") ||
                                  name.includes("ukg")
                                ) {
                                  return "KG";
                                } else if (
                                  name.match(/class\s*[1-5]/) ||
                                  name.match(/^[1-5]/) ||
                                  name.includes("1st") ||
                                  name.includes("2nd") ||
                                  name.includes("3rd") ||
                                  name.includes("4th") ||
                                  name.includes("5th") ||
                                  name.includes("primary")
                                ) {
                                  return "PRIMARY";
                                } else if (
                                  name.match(/class\s*[6-8]/) ||
                                  name.match(/^[6-8]/) ||
                                  name.includes("6th") ||
                                  name.includes("7th") ||
                                  name.includes("8th") ||
                                  name.includes("middle")
                                ) {
                                  return "MIDDLE";
                                } else if (
                                  name.match(/class\s*(9|10)/) ||
                                  name.match(/^(9|10)/) ||
                                  name.includes("9th") ||
                                  name.includes("10th") ||
                                  name.includes("secondary")
                                ) {
                                  return "SECONDARY";
                                } else if (
                                  name.match(/class\s*(11|12)/) ||
                                  name.match(/^(11|12)/) ||
                                  name.includes("11th") ||
                                  name.includes("12th") ||
                                  name.includes("higher") ||
                                  name.includes("senior")
                                ) {
                                  return "HIGHER";
                                }
                                return null;
                              };

                              // Get all unique education levels from teaching preferences
                              const uniqueLevels = new Set();
                              tutor?.classes?.forEach((cls) => {
                                const level = getEducationLevel(cls.name);
                                if (level) uniqueLevels.add(level);
                              });

                              // Get existing levels in the form
                              const existingLevels = new Set(
                                approvalForm.levelBasedPricing.map((p) => p.level)
                              );

                              // Add only new levels that don't exist already
                              const newPricingEntries = [];
                              uniqueLevels.forEach((level) => {
                                if (!existingLevels.has(level)) {
                                  newPricingEntries.push({
                                    level,
                                    hourlyRate: 0,
                                    edushalaMargin: 0,
                                    subjects: [],
                                    numberOfSessions: 0,
                                  });
                                }
                              });

                              // Otherwise add the first unused option so every category
                              // can be configured one pricing entry at a time.
                              const firstUnusedLevel = PRICING_LEVEL_VALUES.find(
                                (level) => !existingLevels.has(level)
                              );
                              if (newPricingEntries.length === 0 && firstUnusedLevel) {
                                newPricingEntries.push({
                                  level: firstUnusedLevel,
                                  hourlyRate: 0,
                                  edushalaMargin: 0,
                                  subjects: [],
                                  numberOfSessions: 0,
                                });
                              }

                              const newPricing = [
                                ...approvalForm.levelBasedPricing,
                                ...newPricingEntries,
                              ];
                              setApprovalForm({ ...approvalForm, levelBasedPricing: newPricing });
                            }}
                          >
                            + Add Level
                          </ArgonButton>
                        </ArgonBox>

                        {approvalForm.levelBasedPricing.map((pricing, index) => (
                          <ArgonBox
                            key={index}
                            sx={{
                              p: 2,
                              mb: 2,
                              border: "1px solid #ddd",
                              borderRadius: "6px",
                              background: "white",
                            }}
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={2}>
                                <ArgonTypography variant="caption" fontWeight="medium" mb={0.5}>
                                  Education Level
                                </ArgonTypography>
                                <Dropdown
                                  value={pricing.level}
                                  options={PRICING_LEVEL_GROUPS}
                                  onChange={(e) => {
                                    const updated = [...approvalForm.levelBasedPricing];
                                    updated[index].level = e.target.value;
                                    setApprovalForm({
                                      ...approvalForm,
                                      levelBasedPricing: updated,
                                    });
                                  }}
                                  width="100%"
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <ArgonTypography variant="caption" fontWeight="medium" mb={0.5}>
                                  Subjects
                                </ArgonTypography>
                                <Autocomplete
                                  multiple
                                  size="small"
                                  disablePortal={false}
                                  disableCloseOnSelect
                                  value={
                                    tutor?.subjects?.filter((subj) =>
                                      pricing.subjects?.includes(subj._id)
                                    ) || []
                                  }
                                  options={tutor?.subjects || []}
                                  getOptionLabel={(option) => option?.name || ""}
                                  isOptionEqualToValue={(option, value) =>
                                    option?._id === value?._id
                                  }
                                  onChange={(e, newValue) => {
                                    const updated = [...approvalForm.levelBasedPricing];
                                    updated[index].subjects = newValue.map((subj) => subj._id);
                                    setApprovalForm({
                                      ...approvalForm,
                                      levelBasedPricing: updated,
                                    });
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder="Select subjects"
                                      size="small"
                                      variant="outlined"
                                    />
                                  )}
                                  renderTags={(value, getTagProps) =>
                                    value.map((option, idx) => (
                                      <Chip
                                        key={option._id || idx}
                                        label={option.name}
                                        size="small"
                                        {...getTagProps({ index: idx })}
                                      />
                                    ))
                                  }
                                  componentsProps={{
                                    popper: {
                                      style: { zIndex: 10000 },
                                    },
                                  }}
                                  // sx={{
                                  //   "& .MuiOutlinedInput-root": {
                                  //     padding: "2px 8px",
                                  //   },
                                  //   "& .MuiAutocomplete-endAdornment": {
                                  //     top: "calc(50% - 12px)",
                                  //   },
                                  // }}
                                />
                              </Grid>
                              <Grid item xs={12} md={2}>
                                <ArgonTypography variant="caption" fontWeight="medium" mb={0.5}>
                                  Salary (₹/hour)
                                </ArgonTypography>
                                <ArgonInput
                                  type="number"
                                  placeholder="140"
                                  value={pricing.hourlyRate}
                                  onChange={(e) => {
                                    const updated = [...approvalForm.levelBasedPricing];
                                    updated[index].hourlyRate = Number(e.target.value);
                                    setApprovalForm({
                                      ...approvalForm,
                                      levelBasedPricing: updated,
                                    });
                                  }}
                                  size="small"
                                />
                              </Grid>
                              <Grid item xs={12} md={2}>
                                <ArgonTypography variant="caption" fontWeight="medium" mb={0.5}>
                                  Margin (%)
                                </ArgonTypography>
                                <ArgonInput
                                  type="number"
                                  placeholder="35"
                                  value={pricing.edushalaMargin}
                                  onChange={(e) => {
                                    const updated = [...approvalForm.levelBasedPricing];
                                    updated[index].edushalaMargin = Number(e.target.value);
                                    setApprovalForm({
                                      ...approvalForm,
                                      levelBasedPricing: updated,
                                    });
                                  }}
                                  size="small"
                                />
                              </Grid>
                              <Grid item xs={12} md={2}>
                                <ArgonTypography variant="caption" fontWeight="medium" mb={0.5}>
                                  No. of Sessions
                                </ArgonTypography>
                                <ArgonInput
                                  type="number"
                                  placeholder="0"
                                  value={pricing.numberOfSessions || 0}
                                  onChange={(e) => {
                                    const updated = [...approvalForm.levelBasedPricing];
                                    updated[index].numberOfSessions = Number(e.target.value);
                                    setApprovalForm({
                                      ...approvalForm,
                                      levelBasedPricing: updated,
                                    });
                                  }}
                                  size="small"
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                md={12}
                                display="flex"
                                justifyContent="flex-end"
                                mt={1}
                              >
                                <ArgonButton
                                  color="error"
                                  size="small"
                                  variant="outlined"
                                  onClick={() => {
                                    const updated = approvalForm.levelBasedPricing.filter(
                                      (_, i) => i !== index
                                    );
                                    setApprovalForm({
                                      ...approvalForm,
                                      levelBasedPricing: updated,
                                    });
                                  }}
                                  sx={{ minWidth: "120px" }}
                                >
                                  Remove
                                </ArgonButton>
                              </Grid>
                            </Grid>
                          </ArgonBox>
                        ))}

                        {approvalForm.levelBasedPricing.length === 0 && (
                          <ArgonTypography
                            variant="caption"
                            textAlign="center"
                            display="block"
                            color="text"
                          >
                            No level-based pricing added. Click &quot;+ Add Level&quot; to add
                            pricing for different education levels.
                          </ArgonTypography>
                        )}
                      </ArgonBox>
                    </Grid>

                    {/* Legacy fields - shown only if no level-based pricing */}
                    {approvalForm.levelBasedPricing.length === 0 && (
                      <>
                        <Grid item xs={12}>
                          <ArgonTypography variant="caption" color="warning" display="block" mb={1}>
                            ⚠️ Legacy Mode: Add level-based pricing above for better control
                          </ArgonTypography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                            Edushala Margin (%)
                          </ArgonTypography>
                          <ArgonInput
                            type="number"
                            fullWidth
                            placeholder="Enter margin"
                            value={approvalForm.edushalaMargin}
                            onChange={(e) =>
                              setApprovalForm({ ...approvalForm, edushalaMargin: e.target.value })
                            }
                            size="small"
                          />
                        </Grid>
                      </>
                    )}
                  </>
                )}

                {/* Rejected Fields */}
                {approvalForm.approvalStatus === "REJECTED" && (
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Rejection Reason *
                    </ArgonTypography>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      placeholder="Enter reason for rejection"
                      value={approvalForm.rejectionReason}
                      onChange={(e) =>
                        setApprovalForm({ ...approvalForm, rejectionReason: e.target.value })
                      }
                      size="medium"
                    />
                  </Grid>
                )}
              </Grid>

              <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                <ArgonButton variant="outlined" onClick={handleApprovalDialogClose}>
                  Cancel
                </ArgonButton>
                <ArgonButton
                  variant="contained"
                  color={approvalForm.approvalStatus === "APPROVED" ? "success" : "error"}
                  onClick={handleApprovalSubmit}
                  disabled={approvalLoading || !approvalForm.approvalStatus}
                  startIcon={
                    approvalLoading ? <CircularProgress size={16} color="inherit" /> : null
                  }
                >
                  {approvalLoading ? "Submitting..." : "Submit"}
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Image Modal */}
      <Dialog
        open={imageModalOpen}
        onClose={() => setImageModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {tutor?.fullName || "Tutor Image"}
          <ArgonButton
            onClick={() => setImageModalOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </ArgonButton>
        </DialogTitle>
        <DialogContent>
          <ArgonBox display="flex" justifyContent="center">
            <img
              src={selectedImage}
              alt={tutor?.fullName || "Tutor Image"}
              style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
            />
          </ArgonBox>
        </DialogContent>
      </Dialog>

      {/* Meeting Dialog */}
      <MeetingDialog
        open={meetingDialog.open}
        onClose={handleCloseMeetingDialog}
        tutorId={id}
        existingMeeting={meetingDialog.existingMeeting}
        onSuccess={handleMeetingSuccess}
      />
    </ArgonBox>
  );
}

export default BasicDetails;
